var messages = {
  privacy: {
    title: "vTrack Service Usage Tips",
    text1: "Thank you for your trusty, welcome using vTrack!",
    text2:
      "In order to better protect your rights and interests, please carefully read and fully understand",
    text3: "User Agreement and Privacy policy",
    end:
      "If you click 'agree', means that you have fully read, understood and accepted all the contents of this agreement, and this agreement will be legally binding. if you click “not agree”, you can exit from this page."
  },
  alert: {
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm",
    cancellationText: "Are you sure to Deactivate Account?",
    updateText: "This page is a new module. Please update to the latest version and try again",
    networkError: "Network error",
    unavailable: "This feature requires access to the client to use",
    download: "Go download",
    reload: "Reload"
  },
  meta: {
    homePage: "Home",
    userPage: "User",
    userManagement: "User management",
    search: "Search",
    more: "More",
    upload: "Upload",
    uploadSuccess: "Upload success",
    uploadFail: "Upload fail",
    loading: "Loading...",
    privacy: "User Agreement and Privacy policy",
    aboutUs: "About us",
    accountDelete: "Account Cancellation",
    kefuList: "Customer service",
    agree: "Agree",
    disagree: "Disagree",
    noMore: "No more",
    input: "Please input",
    require: "Required fields",
    select: "Please select",
    filter: "filter",
    all: "All",
    allFilter: "All filter",
    dateFilter: "Date filter",
    view: "View",
    viewClick: "Click View",
    reset: "Reset",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    delete: "Delete",
    date: "Date",
    beginDate: "Start date",
    to: "To",
    endDate: "End date",
    edit: "Edit",
    editButton: "Edit / View",
    disable: "Disable",
    enable: "Enable",
    display: "Display",
    hide: "hide",
    effective: "Effective",
    searchText: "Search keywords",
    searchType: "Search conditions",
    print: "Print",
    copy: "Copy",
    copySuccess: "Copy success",
    operate: "Operate",
    operateSuccess: "Operate success",
    detail: "Detail",
    basicTitle: "Basic information",
    customerTitle: "Customer type",
    country: "Country",
    city: "City",
    menu: "Operate",
    submit: "Submit",
    chagreTitle: "Charge items",
    currency: "Currency",
    statistics: "Data statistical conditions",
    businessType: "Business types",
    wbType1: "Air Freight",
    wbType2: "Sea Freight",
    wbType3: "Air To Door",
    wbType4: "Sea To Door",
    wbType5: "Express",
    wbType6: "Railway",
    wbType7: "Warehouse",
    wbType8: "Customs",
    wbType9: "Land Transport",
    isConsolidation: "Consolidation",
    year: "",
    month: "",
    day: "",
    saveToAlbum: "Save to the album",
    prevPage: "Previous page",
    nextPage: "Next page",
    noData: "No data",
    yes: "yes",
    no: "no",
    enterprise: "Enterprise",
    personal: "Personal",
    systemLanguage: "System language",
    autoLanguage: "Follow the system",
    saveSuccess: "Save success",
    saveError: "Save fail",
    printError: "Print error",
    notice: "Notice",
    deleteConfirm: "Are you sure to delete this data?",
    backHome: "Home",
    viewDetail: "View detail",
    paySuccess: "Payment success",
    payFailure: "Payment fail",
    selectTotal: "Select-total",
    showStatistics: "Show statistics",
    hideStatistics: "Hide statistics",
    website: "Website",
    newVersion: "Discover a new version",
    updateButton: "Update now",
    laterButton: "Tomorrow",
    scanTitle: "Scan the qrcode",
    scanDes: "Please scan the QR code or barcode",
    scanButton: "Select from the photo album",
    scanError1: "Recognition failed. Please select the correct QR code or barcode",
    scanError2: "The camera is unavailable. Please enable camera permissions",
    popover1: "Scan",
    popover2: "Language",
    scanNotice1: "Please scan the QR code with Alipay for payment",
    scanNotice2: "Please scan the QR code with WeChat for payment",
    add: "Add",
    goToCreate: "Go to create",
    noImage: "No pictures",
  },
  router: {
    home: "vTrack",
    print: "Print page",
    enterpriseWorkbench: "Enterprise workbench",
    workbenchBank: "My bank account number",
    workbenchSupplier: "Supplier information collector",
    buildWayBillNo: "Create Waybill Number",
    checkWaybill: "Query management",
    checkWaybillDetail: "Waybill order detail",
    billsReceivable: "Debit note",
    supplierCostEntry: "Supplier costs",
    logisticsStatus: "Logistics status",
    jobSummary: "Job summary",
    orderWayBill: "Order center",
    orderWayBillDetail: "Order detail",
    goodsFiles: "Goods files center",
    goodsFilesDetail: "Goods files detail",
    preAlertDetail: "Pre-Alert detail",
    basicInfo: "Customer list",
    basicInfoDetail: "Customer detail",
    basicInfoAgentList: "Overseas agent list",
    basicInfoAgentDetail: "Overseas agent detail",
    banckAccountInfo: "Bank account list",
    banckAccountInfoDetail: "Bank account detail",
    contactStaff: "Contact list",
    contactStaffDetail: "Contact person detail",
    contractManagement: "Contract management",
    contractManagementDetail: "Contract detail",
    receivingAccountManagement: "Receiving account list",
    receivingAccountManagementDetail: "Receiving account detail",
    expenseNameManagement: "Bill payment list",
    expenseNameManagementDetail: "Bill payment detail",
    exchangeRateInfo: "Exchange rate list",
    exchangeRateInfoDetail: "Create rate",
    exchangeRateInfoLog: "Exchange rate log",
    invoiceItemList: "Invoice item list",
    invoiceItemListDetail: "Invoice item detail",
    reportQuerySummary: "Query summary",
    payrollDetails: "Business payment request",
    payrollList: "Operate payment request",
    payrollRequest: "Operate cost request",
    payrollPayment: "Pay the operation request",
    payrollRecords: "Payment record information",
    reportQuerySummaryDetail: "Collection and payment",
    profitableList: "Profitable list",
    profitableListDetail: "Profit statistics details",
    finishedCheckBillsSummary: "Finished bills checked",
    finishedCheckBillsSummaryDetail: "Finished bills checked detail",
    creditedDetails: "Credited list",
    creditedDetailsInfo: "Credited details",
    taxInvoice: "Tax invoice",
    taxInvoiceDetail: "Invoice detail",
    financialRequest: "Financial request",
    financialRequestDetail: "Request detail",
    financialAudit: "Financial audit",
    financialAuditDetail: "Audit detail",
    paymentInvoice: "Payment invoice",
    cargoStatistics: "Cargo statistics",
    lineChartStatistics: "Line chart statistics",
    expenseStatistics: "Expense statistics",
    expenseStatisticsDetail: "Request details list",
    customerBusinessStatistics: "Customer business statistics",
    customerBusinessStatisticsDetail: "Customer payment detail",
    customerBusinessStatisticsCustomerInfo: "Receipts or payments",
    seaFreightDataStatistics: "Sea freight data statistics",
    seaFreightDataStatisticsDetail: "Sea freight data statistics detail",
    warehouseList: "Warehouse management",
    warehouseDetail: "Warehouse information",
    warehouseSettings: "Warehouse form setting",
    warehouseSettingsDetail: "Warehouse form content settings",
    warehouseDelivery: "Warehouse delivery",
    warehouseDeliveryDetail: "Warehouse delivery detail",
    warehouseBill: "Warehouse entry work order",
    warehouseBillDetail: "Warehouse work order",
    warehouseProfitAccounting: "Warehouse profit",
    warehouseOperationLogList: "Cargo operation logs",
    advertList: "Advert list",
    advertDetail: "Advert detail",
    restrictedList: "Restricted list",
    restrictedDetail: "Restricted detail",
    emailConfig: "Email Configuration",
    emailConfigDetail: "Configuration detail",
    quoteList: "Quote list",
    quoteDetail: "Quotation detail",
    quoteCreate: "Quotation sheet",
    orderCenterList: "Order center list",
    commissionDetail: "Entrust detail",
    commissionCreate: "Cargo arrangement SOP",
    accountingList: "Accounting list",
    accountingDetail: "Accounting detail",
    supplierServiceInformation: "Supplier service information",
    supplierInformation: "Supplier information",
    answerDetail: "Supplier answer list",
    overseasGrid: "Overseas grid",
    overseasDetail: "Overseas agent quotation",
    assetsStatistics: "Assets statistics",
    assetsStatisticsDetail: "Assets statistics detail",
    assetsStatisticsRecord: "Service handover record",
    employeeInformation: "Employee file information",
    employeeManagement: "Employee management",
    employeeDetail: "Employee detail",
    privacy: "User Agreement and Privacy policy",
    accountDeletion: "Account cancellation",
    aboutUs: "About us",
    kefuList: "Customer service",
    currencySettings: "Currency setting",
    currencySettingsDetail: "Currency detail",
    invoiceTitle: "Invoice title",
    consumptionRecord: "Consumption record",
    financialAuditProcessSettings: "Financial audit setting",
    getWayBillOperationLog: "Operation Log",
    expenseCategorySettings: "Expense Category Setting",
    userList: "User list",
    userDetail: "User information",
    roleList: "Role list",
    roleDetail: "Set right",
    store: "Store",
    payCompletion: "Payment detail",
    payQrcode: "Scan to pay",
    accountStatements: "Account statement",
    accountStatementsDetail: "Client fund transfer detail",
    clientFundDetail: "Client fund detail",
    clientFundUseList: "Client fund usage details",
    clientFundExchange: "Client fund exchange record",
    clientFundDataList: "Data detail list",
    businessEntry: "Client fund business entry",
    businessEntryDetail: "Business entry detail",
    financeEntry: "Client fund finance entry",
    financeEntryDetail: "Finance entry detail",
    clientFundDetailExchange: "Client fund exchange",
    clientFundDetailWriteOff: "Client fund write off",
    antiMoneyLaunderingList: "Anti-money list",
    antiMoneyLaunderingDetail: "Anti-money detail",
    antiMoneyLaunderingQuery: "Anti-money query results",
    temuManifestList: "TEMU order list",
    temuManifestDetail: "TEMU order detail",
    tmsDetail: "TMS order information",
    vehiclesList: "Vehicle management",
    vehiclesDetail: "Vehicle detail",
    expressEmployeeList: "Express employee list",
    expressEmployeeDetail: "Express employee detail",
    cargoWarehousingList: "Cargo transportation management",
    cargoWarehousingDetail: "transportation detail",
    cargoWarehousing: "Transportation operate",
    cargoWarehousingException: "Order exception handling",
    cargoWarehousingExceptionRecords: "Exception record",
    quotationManagement: "Quotation management",
    quotationWarehouse: "Warehouse information",
    quotationInformation: "Quotation information",
    quotationFreight: "Freight information",
    quotationCustomerDiscount: "Customer discount",
    quotationCustomerDiscountDetail: "Customer discount detail",
    quotationSupplierCreate: "Supplier quotation details",
    waitingForStorage: "Warehouse list",
    hasBeenStored: "Stored list",
    hasBeenStoredDetail: "Generate waybill number",
    departed: "Shipping list",
    departedDetail: "Customer orders",
    freightPriceCalculator: "Freight price calculator",
    cargoWarehousingEditAddress: "Edit shipping address",
    businessEntitySettings: "Business entity settings",
    businessEntitySettingsDetail: "Business entity detail",
    goodsInventory: "Purchasing goods inventory",
    goodsInventoryCreate: "Product detail",
    goodsInventoryQuotation: "Product quotation",
    goodsInventoryQuotationDetail: "Quotation detail",
    tradeOrder: "Trade order",
    tradeOrderCreate: "Trade order create",
    tradeOrderReconciliation: "Customer capital reconciliation",
    procurementQuotationSettings: "Quotation unit setting",
    procurementQuotationSettingsDetail: "Quotation unit detail",
    customerHome: "Customer home",
    customerInfo: "Enterprise information",
    logisticsSection: "Logistics section",
    freightInquiry: "Freight inquiry",
    freightInquiryDetail: "Freight inquiry detail",
    customerQuotationDetail: "Quotation detail",
    shippingAddress: "Delivery Address",
    addAddress: "Create delivery address",
    editAddress: "Edit delivery address",
    myWallet: "My wallet",
    paybillList: "Payable bill",
    myWalletRechange: "Account recharge",
    orderManagement: "Order management",
    orderManagementDetail: "Order detail",
    quotationIntegration: "Points rules",
    quotationIntegrationHistory: "The history of point rules",
    exportGoodsStatistics: "Export goods statistics",
    entrustOrder: "Entrust order",
    entrustOrderList: "Entrust order list",
    entrustOrderCreate: "Create entrust order",
    entrustOrderDetail: "Entrust order detail",
    freightOrder: "Freight order",
    freightOrderList: "Freight order list",
    freightOrderCreate: "Freight order detail",
    warehouseManagement: "Warehouse management",
    warehouseQuery: "Cargo storage inquiry",
    warehouseStatement: "Cargo flow statement",
    financialCounting: "Financial counting",
    debtList: "Financial counting list",
    debtDetail: "Payable bill"
  },
  activate: {
    title1: "Please input the user information",
    title2: "Please input the company information",
    headImg: "Avatar",
    username: "User name",
    email: "Email",
    save: "Save",
    companyLogoPic: "Company Logo picture",
    businessLicence: "Business license",
    officialSealPic: "Official seal picture",
    companyName: "Company name",
    companyProfileCn: "Company profile ( locality )",
    companyProfileEn: "Company profile ( English )",
    legalPersonName: "Company legal person",
    creditCode: "BR / VAT NO.",
    detailAddress: "Full address"
  },
  auth: {
    staff: "Internal staff",
    customer: "Enterprise customer",
    login: "Log in",
    logInSuccess: "Log In success",
    inputPhoneNumber: "Please input the phone number",
    inputEmail: "Please input the email",
    inputCustomerNumber: "Please input the customer number",
    inputCorrentPhoneNumber: "Please input the correct phone number",
    inputCorrentEmail: "Please input the correct email",
    phoneNumber: "Phone number",
    email: "Email",
    inputVcode: "Verification code",
    inputUsername: "Please input phone number or email",
    inputPassword: "Please input the password",
    inputCompanyCode: "Please input the company code ( optional )",
    register: "Sign up",
    setAccountInfo: "Set account information",
    sendAuthCode: "SMS code",
    next: "Next",
    backLogin: "Back to login",
    verificationCodeInfo: "Verification code has been sent",
    username: "Username",
    inputPaw: "Please input your password",
    pawInfo: "8 Characters with Digit Mix Letter.",
    registerSuccess: "Register successfully",
    correctError: "Please input the correct password first",
    confirm: "Confirm",
    logout: "Logout",
    customerNumber: "Customer number",
    forgetPassword: "Forget password",
    resetPassword: "Reset password",
    freeze: "Account frozen",
    newPassword1: "Please input your new password",
    newPassword2: "Please re-input the new password",
    diffPassword: "The two password entries are inconsistent",
    activate: "Activate account",
    role: "Role",
    companyName: "Company name",
    companyCode: "Company code",
    tick: "Please tick ",
    rulesAndProtocols:
      "I have read and agreed to the User Agreement and Privacy Policy",
    pickerType1: "Login account type",
    pickerType2: "Register account type",
    verifyText: "Account needs to be verifiy",
    verifyCode: "VerifiyCode",
    get: "Send",
  },
  information: {
    title: "Personal information",
    input: "Please input",
    select: "Please select",
    companyName: "Company full name",
    companyNameEn: "Company name in English",
    companyNameSn: "Company name in short",
    legalPerson: "Legal representative",
    telePhone: "Tel No.",
    webSite: "Website",
    address: "Address",
    certificate: "BR license",
    personalPassport: "Passport number",
    personalID: "Identification number",
    personalIDSn: "Customer id number",
    customerPhone: "Contact No.",
    customerPassword: "Customer password",
    email: "Email",
    country: "Country",
    city: "City",
    password: "Password",
    submit: "Submit",
    save: "Save",
    alert: "Please verify your information",
    userInfo: "User information",
    avatar: "Avatar",
    card: "Personal business card",
    userName: "User name",
    phone1: "Mobile number 1",
    phone2: "Mobile number 2",
    fixedPhone: "Fixed-line",
    wechat: "Wechat id",
    qq: "QQ number",
    whatsapp: "Whatsapp number",
    website: "Website",
    eCard: "Business card",
    chinese: "Local language",
    english: "English",
    name: "Name",
    department: "Department",
    position: "Position",
    mailingAddress: "Mailing address",
    individualResume: "Personal profile",
    serviceSectionIntroduction: "Service introduction",
    projectCase: "Project case",
    personalSayings: "My motto",
    filename: "File name",
    customizeName: "Customize name",
    view: "View",
    upload: "Upload",
    customerNumber: "Customer number",
  },
  enterpriseInfo: {
    title: "Enterprise information",
    companyInfo: "Company information",
    companyLogo: "Company Logo",
    licence: "Business license",
    officialSeal: "Official seal",
    companyCode: "Company code",
    companyName: "Company name",
    companyProfileCN: "Company profile ( locality )",
    companyProfileEN: "Company profile ( English )",
    legal: "legal person",
    creditCode: "BR / VAT NO.",
    detailAddress: "Full address",
    submit: "Submit",
  },
  workbench: {
    username: "My name",
    roleName: "System role",
    phoneNumber: "Phone number",
    companyName: "Company name",
    eCard: "Business card",
    createRequest: "Apply for reimbursement",
    myBankAccount: "My bank account number",
    accountName: "Bank account name",
    accountNo: "Bank account",
    bankName: "Bank name",
    qrcode: "E-wallet QR code",
    saveBankInfo: "Save bank information",
    supplierCollector: "Supplier information collector",
    shareMessageCN: "share message ( locality )",
    shareMessageEN: "share message ( English )",
    shareQrCode: "Qrcode of the questionnaire",
    saveMessage: "Save message",
    viewButton: "View payment request",
    freightPriceCalculator: "Freight price calculator",
    h5QrCode: "Logistics station",
  },
  employee: {
    title1: "Process enrollment",
    title2: "Personal information",
    title3: "Emergency contact",
    title4: "Education",
    title5: "Language",
    title6: "Training course",
    title7: "Certificate",
    title8: "Bank account",
    title9: "Certificate filing",
    photo: "Personal photo",
    entryDate: "Entry date",
    position: "Position",
    surname: "Name",
    phoneNumber: "Phone number",
    idCardNumber: "Identity card number",
    marital: "Marital status",
    mOption1: "unmarry",
    mOption2: "married",
    address: "Address",
    nationality: "Nationality",
    nativePlace: "NativePlace",
    gender: "Gender",
    male: "Male",
    female: "Female",
    birthDate: "Birth date",
    contactName: "Contact name",
    contactPhone: "Contact phone number",
    education: "Education",
    school: "Graduate school",
    enrollmentDate: "Enrollment date",
    graduationDate: "Graduation date",
    languageName: "Name",
    listen: "Listen",
    say: "Say",
    read: "Read",
    write: "Write",
    lOption1: "General",
    lOption2: "Practised",
    lOption3: "Mastery",
    courseName: "Course title",
    institutions: "Training institution",
    beginDate: "Training start date",
    endDate: "Training end date",
    certificate: "Certificate",
    cBeginDate: "Effective start date",
    cEndDate: "Effective end date",
    payeeName: "Name of payee",
    bankName: "Bank name",
    bankAccount: "Bank account",
    idCard: "Identity card",
    view: "View",
    upload: "Upload",
    graduationBook: "Graduation certificate",
    resignBook: "Resignation certificate",
    resume: "Personal resume",
    sourceTitle: "Enterprise allocation resources",
    allocatingResource: "Allocate resources",
    receivingServer: "Receiving server",
    receivePort: "Receive port",
    sendServer: "Send server",
    sendPort: "Send port",
    fixedAssets: "Fixed assets",
    digitalAssets: "Digital assets",
    assetType: "Asset type",
    className: "Class name",
    goodsName: "Product name",
    accountNumber: "Account number",
    welcomeLetter: "Welcome letter",
    photo: "Photo",
    cardFront: "Card front",
    cardBack: "Card back",
    mailSignature: "Mail signature",
    assetNoData: "No data for this asset",
    classNoData: "No data for this category"
  },
  accountDeletion: {
    accountDelete: "Account Cancellation",
    accountDeleteSuccess: "Account deactivated successfully",
    label1: "Information modification issues",
    label2: "Other issues",
    issue1: "Unable to change account name",
    issue2: "Mobile credit issues",
    issue3: "Change of email",
    issue4: "Duplicate account",
    issue99: "Input issues",
    nextStep: "Next step",
    error: "Please select a issues",
    termsText: "I have read and agree to the 《Important Reminders for Account Cancellation》"
  },
  aboutUs: {
    currentVersion: "Current version",
    updateVersion: "Version update"
  },
  checkWaybill: {
    platformOrder: "Platform order",
    temuOrderNumber: "TEMU order number",
    jobNumber: "Job number",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    shippingDate: "Shipping date",
    type: "Type",
    goodState: "Cargo status",
    warehouse: "Warehouse",
    driver: "Driver",
    vehicle: "Vehicle",
    paymentStatus: "Payment Status",
    deliveryCustomer: "Shipper name",
    receiveCustomer: "Consignee name",
    receiveCountry: "Receive country",
    bulkUpdate: "Batch modify status",
    fileList: "Asset file list",
    export1: "Export",
    export2: "Import",
    addWbNumber: "Add master bill number",
    repeatBill: "Do not select an existing master waybill number line",
    selectSingle: "Please select a single master waybill number",
    noWbNumber: "The master waybill number of this waybill has not been added yet",
    editWbNumber: "Modify master bill number",
    viewWbNumber: "View master bill number",
    deleteWbNumber: "Delete waybill",
    addSuccess: "Add Success",
    editSuccess: "Edit Success",
    searchText: "Search waybill number",
    deliveryPhone: "Shipper's phone number",
    receivePhone: "Consignee's phone number",
    createTime: "Shipping time",
    goodsName: "Goods name",
    weight: "Weight",
    pNumber: "Quantity",
    added: "Added",
    notAdded: "Not added",
    preAlertTitle: "PreAlert files",
    mainNoButton: "MAWB No. files",
    dialogBillTitle: "printing options ( optional )",
    isLogo: "Display the enterprise LOGO",
    isName: "Display English name of Enterprise",
    isDraft: "Draft watermark",
    isTelexRelease: "Telex release",
    isOriginal: "Original",
    dialogWarehouseTitle: "The goods will be delivered to the following warehouse",
    warehouseNameOrNumber: "Warehouse name or number",
    warehouseOwnership: "Warehouse ownership",
    warehouseList: "Warehouse list",
    sheet1: "Debit note",
    sheet2: "Supplier costs",
    sheet3: "Select warehouse",
    sheet4: "Preview of B/L",
    sheet5: "Preview of face sheet",
    sheet6: "Arrival Notice / Work order",
    preAlertNotice: "Check the work number of the same master waybill number",
    cargoNotice: "Please tick the waybill first",
    expressWarehouse: "Express cargo warehousing",
    mawbNumber: "The number of large boxes",
    dialogSheetTitle: "printing options",
    isPrintVtrackLabel1: "Printed distributor label",
    isPrintVtrackLabel2: "Printed vtrack label"
  },
  billsReceivable: {
    project: "Project",
    quantity: "quantity",
    unitPrice: "Unit price",
    total: "Total amount",
    bankAccount: "Bank account",
    accountName: "Account name",
    bankName: "Bank name",
    address: "Address",
    remark: "Remark",
    emailShare: "Email share",
    email: "Email address",
    placeholderEmail: "Input in multiple email addresses separated by ','",
    selectBill: "Please select payment",
    noAccount: "No bank account"
  },
  supplierCostEntry: {
    title: "Cost information details",
    customName: "Customer name",
    customerNumber: "Customer number",
    quantity: "quantity",
    unitPrice: "Unit price",
    total: "Total amount",
    referNo: "Supplier billing reference number",
    attachments: "Attachment",
    taxInvoice: "Tax invoice",
    remark: "Remark",
    amount: "Total amount",
  },
  logisticsStatus: {
    serialNumber: "Serial number",
    logisticsCn: "Logistics Status ( Locality )",
    logisticsEn: "Logistics Status ( English )",
    logisticsSn: "Abbreviation of logistics state",
    addState: "Add logistics status",
    editState: "Edit logistics status",
    stateCn: "Logistics Status Description / Locality",
    stateEn: "Logistics Status Description / English",
    sortNumber: "Sort number",
    add: "Create",
  },
  jobSummary: {
    searchText: "Master / House waybill number",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    kefu: "CS",
    marketing: "Marketing",
    sales: "Sales",
    operation: "Operation",
    tradeTitle: "Trade logistics",
    deliveryPort: "Departure port",
    destinationPort: "Arrival port",
    costTitle: "Cost detail",
    financialAccountNo: "Financial Ref No.",
    customerNumber: "Customer number",
    customName: "Customer name",
    billReferNo: "Supplier Billing Reference Number",
    totalPayable: "Total payable",
    totalPayableBalance: "Payable balance",
    viewCost: "View cost",
    deleteCost: "Delete cost",
    subTotal: "Sub-total",
    rate: "Rate",
    totalAmount: "Total Amount",
    sellTitle: "Sell detail",
    invoiceNo: "Invoice No.",
    customerNo: "Customer No.",
    totalReceive: "Total receivable",
    totalReceiveBalance: "Recivable balance",
    viewSell: "View sell",
    deleteSell: "Delete sell",
    receTotalAmount: "Total Amount",
    profitTotalAmount: "Total Amount",
    unloadText: "Please input master B/L or house B/L to search",
    notice: "Notice",
    deleteCheck1: "Are you sure to delete this cost?",
    deleteCheck2: "Are you sure to delete this sell?",
  },
  orderWayBill: {
    sopNumber: "SOP number",
    companyNameSn: "Customer abbreviation",
    customerNumber: "Customer number",
    businessType: "Business types",
    deliveryCity: "Delivery City",
    destinationCity: "Destination City",
    salesUsername: "Sales",
    createTime: "Create time",
    sales: "Sales",
    pNumber: "Quantity",
    volume: "Volume",
    weight: "Weight",
    goodsName: "Goods name",
    orderState: "Order status",
    generate: "Generate the waybill number",
  },
  goodsFiles: {
    sopNumber: "SOP number",
    sideWbNumber: "House B/L",
    companyNameSn: "Customer abbreviation",
    customerNumber: "Customer number",
    businessType: "Business types",
    deliveryCity: "Delivery City",
    destinationCity: "Destination City",
    createTime: "Create time",
    erNumber: "Entrusted reference number",
    date: "Date",
    commission: "Electronic booking",
    contract: "Contract",
    quotation: "Quotation",
    supplier: "Supplier",
    emailAddress: "Email address",
    warehouseNumber: "Warehouse entry No.",
    supplierPhone: "Supplier mobile number",
    invoice: "Invoice",
    packingList: "Packing list",
    noticeBill: "Storage notice bill",
    fileList: "File list",
    emailShare: "Email share",
    unupload: "Not uploaded yet",
    clickShare: "Click to share",
    goodsFiles: "Cargo list",
    saveButton: "Save goods documents",
    viewFile: "View file",
    supplierFileList: "Supplier file list",
    sendInvite: "Send invitation",
    placeholderEmail: "Input in multiple email addresses separated by ','",
  },
  preAlert: {
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    businessType: "Business types",
    deliveryCity: "Delivery City",
    destinationCity: "Destination City",
    status: "Status",
    state1: "Unconfirm",
    state2: "Confirmed",
    flightNumber: "Flight No.",
    shipmentPortAgent: "Shipment port agent",
    destinationAgent: "Destination agent",
    dateType: "Date type",
    receiptDate: "Date of receipt",
    tab1: "Received",
    tab2: "Sent",
    totalHawb: "Total of HAWB",
    transitshipment: "Transitshipment?",
    totalNumber: "Total No.of Packing",
    weight: "Gross Weight",
    volume: "Volume",
    etd: "ETD",
    atd: "ATD",
    eta: "ETA",
    ata: "ATA",
    remark: "Remark",
    log: "Operation logs",
    operator: "Operator",
    date: "Date",
    mail: "Mail sending recipient",
    push: "VTRACK push to",
    companyLogo: "Company Logo",
    companyName: "Company name",
    companyCode: "Company code",
    companyUser: "Enterprise user",
    cargoType: "Cargo Type",
    total: "Total",
    others: "Other documents",
    remarkPlaceHolder:
      "Cargo Handling Remark ( Only main part will be print without tick )",
    printRemark: "Print remark",
    detailList: "Work order list",
    button1: "VTRACK internal push",
    button2: "Send an email",
    email: "Email address",
    placeholderEmail: "Input in multiple email addresses separated by ','",
    preAlertTitle: "PreAlert files",
    emailLabel: "Please select the file you need to send",
    file1: "House B/L",
    file2: "Arrival notice",
    workSheet: "Generate work order",
    noticeText: "Do you want to generate the warehouse entry work order?"
  },
  basicInfo: {
    companyName: "Company name",
    companyNameEn: "Company English Name",
    companyNameSn: "Customer abbreviation",
    companyAddress: "Company address",
    companyCode: "Related company Code",
    legalPerson: "Company legal person",
    telePhone: "Fixed-line",
    webSite: "Enterprise website",
    personalID: "Customer id number",
    personalPassport: "Customer passport number",
    customerNumber: "Customer Number",
    customerPhone: "Customer phone number",
    customerPassword: "Customer password",
    businessLicence: "Business license",
    area: "Area",
    receivable: "Balance",
    status: "Status",
    operationInfo: "Operation Instruction",
    addPeople: "Add By",
    referrer: "Referrer",
    addButton: "Create customer",
    refer: "Refer by",
    password: "password",
    createDate: "Create date",
    createdBy: "Created By",
    cityName: "City Name",
    addAgentButton: "Create agent",
    phoneNumber: "Contact Number",
    contact: "Contact",
    email: "Email",
    address: "Address",
    notes: "Notes",
    createType: "Customer account type",
    createType1: "vTrack account",
    createType2: "Express account",
    createType3: "TEMU express account",
    createType4: "Express consignee Account",
  },
  bankAccount: {
    searchText: "Search customer number",
    customerNumber: "Customer Number",
    customerName: "Customer Name",
    currency: "Currency",
    accountName: "Account name",
    bankNumber: "Bank Number",
    status: "Status",
    accountState: "Account status",
    addButton: "Create account",
    bankName: "Bank name",
    bankRegion: "Bank Region",
    bankAddress: "Bank Address",
    companyAddressEn: "Company english address",
    enterpriseId: "Tax ID Number",
    clerk: "Entry clerk",
    none: "This customer number does not exist"
  },
  contactStaff: {
    customerNumber: "Customer Number",
    contact: "Contact",
    customerPhone: "Customer phone number",
    addButton: "Create contact",
    email: "Email",
    qqNumber: "QQ",
    wechat: "Wechat",
    telePhoneNumber: "TelePhone",
    liaison: "Liaison",
  },
  contractManagement: {
    contractNumber: "Contract number",
    contractName: "Name of the contract",
    customerShort: "Customer short name",
    validityDate: "Period of validity",
    creditLimit: "Credit limit",
    customerNumber: "Customer Number",
    addButton: "Create contract",
    conclusion: "Contract's conclusion",
    dIssueBy: "Issued By",
    validity: "Validity date",
    creditDays: "Credit days",
    attachmentList: "Attachment list",
    creditAmount: "Credit Amount",
  },
  receivingAccountManagement: {
    searchText: "Search account name",
    accountNickName: "Account nick name",
    accountName: "Account name",
    bankName: "Bank name",
    accountNumber: "Account number",
    status: "Status",
    accountState: "Account status",
    addButton: "Create account",
    address: "Enterprise address",
    remark: "Remark",
    accountCollectionType: "Account collection type",
    collectionType1: "Alipay",
    collectionType2: "Wechat",
    collectionType3: "FLYPAY",
    collectionType5: "Express fee",
  },
  expenseNameManagement: {
    searchText: "Search payment project",
    paymentProject: "Item name ( Locality )",
    paymentProjectEn: "Item name ( English )",
    addButton: "Create payment project",
  },
  exchangeRateInfo: {
    currency: "Currency",
    rate: "Rate",
    time: "Time",
    addButton: "Create rate",
    searchText: "Search currency",
    log: "Operation log",
    content: "Operation Content",
    username: "Operator",
    createTime: "Operation time",
  },
  invoiceItemList: {
    searchText: "Search project name",
    itemName: "Item name ( Locality )",
    itemNameEn: "Item name ( English )",
    addButton: "Create invoice item",
  },
  reportQuerySummary: {
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    financialAccountNo: "Cost invoice No",
    deliveryPort: "Departure port",
    destinationPort: "Arrival port",
    invoiceNo: "Invoice No.",
    createDate: "Invoice Date",
    total: "Invoice Amount",
    payerName1: "Payer Name",
    payerName2: "Payer Name",
    recommend: "Referrer",
    wbNumber: "Master or House B/L",
    warehouseWorkNumber: "Warehouse job number",
    jobNumber: "Job number",
    customerNumber: "Customer number",
    companyName: "Company name",
    dataOtion0: "Search by invoice No.",
    dataOtion1: "Search by logistics job",
    dataOtion2: "Search by warehousing job",
    dataOtion3: "Search by trade order",
    bill: "Generate payment request",
    tab1: "Payment of receivable",
    tab2: "Payment of payable",
    tradeTitle: "Trade logistics",
    atd: "ATD",
    amountTitle: "Trade amount",
    outStandingDays: "Out Standing Days",
    creditBalance: "Credit Amount Balance",
    balance: "Recivable Balance",
    totalBalance: "Total balance receivable",
    rate: "Rate",
    taxInvoice: "Tax Invoice Record",
    invoiceNumber: "Invoice Application No.",
    invoiceFile: "Tax invoice file",
    billDetail: "Bill Number Details",
    viewCost: "View cost",
    payrollRequest: "Payroll request",
    subTotal: "Sub-total",
    unreceiveTotal: "Unreceive total",
    totalPayableBalance: "Total payable balance",
  },
  payrollDetails: {
    title1: "Payment request",
    title2: "Supplier collection information",
    title3: "Account",
    title4: "Payment work order number",
    title5: "Approval process",
    companyLogo: "Company Logo",
    companyName: "Company name",
    applyDate: "Apply date",
    paymentRecordNumber: "Payment record number",
    voucherNumber: "Voucher number",
    lastDate: "Latest payment date",
    remark: "Remark",
    supplierCode: "Supplier code",
    supplierName: "Supplier name",
    addAccount: "Add an account",
    addSuccess: "Add Success",
    bankName: "Bank name",
    accountNo: "Bank account",
    bankAccount: "Bank account",
    accountDetail: "Account detail",
    accountCurrency: "Account currency",
    bankRegion: "Bank Region",
    bankAddress: "Bank address",
    addressEn: "English address of enterprise",
    enterpriseId: "Tax ID Number",
    financialAccountNo: "Financial Ref No.",
    workNumber: "Work number",
    payAmount: "Pay amount",
    requestCount: "Request count",
    collection: "Collection state",
    receivedTotal: "Received Total Amount",
    paidTotal: "Paid Total Amount",
    profitAmount: "Profit total amount",
    totalcreditAmount: "Total credit amount",
    profitPercent: "Profit percentage",
    paymentCurrency: "Request currency",
    requestAmount: "Request Amount",
    position: "Position",
    username: "Username",
    approvalState: "Approval status",
    aState1: "Unapply",
    aState2: "Pending approval",
    aState3: "Agree",
    aState4: "Disagree",
    approvalResult: "Approval result",
    approvalUser: "Approvel user name",
    opinions: "Approvel opinions",
    auditTime: "Audit time",
    approvalOperate: "Approvel operate",
    agree: "Agree",
    disagree: "Disagree",
    resubmit: "Resubmit",
    saveChange: "Save this change",
    tSave: "Temporary save",
    cancelApply: "Cancel this apply",
  },
  payrollList: {
    position: "Position",
    type: "Request type：Operate",
    paymentRecordNumber: "Payment record number",
    applicant: "Applicant",
    department: "Department",
    submitTime: "Submit time",
    submitCount: "Submit count",
    currency: "Currency",
    costAmount: "Amount of expense",
    menthodState: "Payment method",
    mState1: "Cash",
    mState2: "E-wallet",
    mState3: "Bank transfer",
    approvalState: "Approval status",
    aState1: "Pending approval",
    aState2: "Completed",
    aState3: "Cancel",
    aState4: "Reject",
    aState5: "Approval completed",
    paymentState: "Payment state",
    pState1: "Unpaid",
    pState2: "Paid",
    systemCode: "Payment voucher number",
    totalBatch: "Total bacth",
    uploadDate: "Certificate upload date",
    button1: "Audit",
    button2: "Pay",
    button3: "Edit operate payment request",
    button4: "Request detail",
    button5: "Operate request",
    paymentTitle: "Please upload the payment voucher",
    payReceipt: "Payment receipt",
  },
  profitableList: {
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    wbNumber: "Master or House B/L",
    warehouseWorkNumber: "Warehouse job number",
    invoiceNo: "Invoice No.",
    companyName: "Company name",
    userType: "User type",
    usType1: "Operator",
    usType2: "Sales",
    usType3: "Service",
    usType4: "Market",
    jobNumber: "Job number",
    dataOtion0: "Search by invoice No.",
    dataOtion1: "Search by logistics job",
    dataOtion2: "Search by warehousing job",
    dataOtion3: "Search by trade order",
    refer: "Refer by",
    tradeTitle: "Trade logistics",
    deliveryPort: "Departure port",
    destinationPort: "Arrival port",
    atd: "ATD",
    amountDetail: "Amount detail",
    receivedTotal: "Received Total Amount",
    receivedAmount: "Receive amount",
    paidTotal: "Paid total amount",
    payAmount: "Payment amount",
    subProfit: "Sub-total Profit",
    rate: "Rate",
    received: "Total amount received",
    paid: "Total amount of payment",
    profits: "Total profit",
  },
  finishedCheckBillsSummary: {
    nuclearAccountNo: "Processing account record",
    creditDate: "Credit Date",
    customerName: "Customer Name",
    nuclearType: "Processing type",
    wbNumber: "Master or House B/L",
    customerNumber: "Customer number",
    companyName: "Company name",
    nuType1: "Receivable",
    nuType2: "Payable",
    nuType3: "Balance",
    all: "All",
    dataOtion1: "Search by logistics job",
    dataOtion2: "Search by warehousing job",
    bank: "Bank of transation",
    nuclearTitle: "Nuclear title",
    receivableAmount: "Received Amount",
    creditAmount: "Credit Amount",
    details: "Details",
    payReceipt: "Payment receipt",
    warehouseWorkNumber: "Warehouse job number",
    workOrderNumber: "Work order number"
  },
  taxInvoice: {
    title: "Tax invoice",
    mainWbNumber: "Master Way Bill No.",
    sideWbNumber: "House Way Bill No.",
    wbNumber: "Master or House B/L",
    invoiceNo: "Invoice No.",
    billDate: "Invoice Date",
    payerName1: "Payer Name",
    payerName2: "Payer Name",
    invoiceAmount: "Invoice total amount",
    invoiceTotal: "Invoice sub-total",
    invoiceAmountSn: "Invoice amount",
    invoiceType: "Invoice type",
    invoiceType1: "full invoice",
    invoiceType2: "a part of invoice",
    invoiceNumber: "Tax invoice No.",
    applyDate: "Apply date",
    invoiceDate: "Apply Data",
    issuedDate: "Issued Data",
    warehouseWorkNumber: "Warehouse job number",
    customerNumber: "Customer number",
    companyName: "Company name",
    recommend: "Referrer",
    all: "All",
    dataOtion1: "Search by logistics job",
    dataOtion2: "Search by warehousing job",
    invoiceItem: "Inovice item",
    remark: "Remark",
    tab1: "Pending List",
    tab2: "Applied List",
    tab3: "invoiced List",
    applyInvoice: "Apply full invoice",
    applyHalfInvoice: "Apply a part of invoice",
    refundApplyInvoice: "Cancel tax invoice",
    refundInvoice: "Invoice rollback",
    tradeTitle: "Trade logistics",
    deliveryPort: "Departure port",
    destinationPort: "Arrival port",
    atd: "ATD",
    amountTitle: "Trade amount",
    itemName: "Item name",
    applicant: "Invoice applicant",
    bankAccountInfo: "Bank account information",
    currency: "Curreny",
    accountName: "Account name",
    bankName: "Bank name",
    bankRegion: "Bank Region",
    bankNumber: "Bank Number",
    bankAddress: "Bank Address",
    companyAddressEn: "Company English address",
    enterpriseId: "Tax ID Number",
    telephone: "Business phone",
    address: "Business address",
    viewInvoice: "View tax invoice",
    uploadinvoice: "Upload tax invoice",
    emailAddress: "Email address",
    invoiceShare: "Invoice share",
    billDetail: "Bill Number Details",
    addInvoice: "Add tax invoice",
    invoiceFile: "Tax invoice file",
  },
  payrollRequest: {
    title: "Expense request",
    costCate: "Expense category",
    startDate: "Start date",
    to: "to",
    endDate: "End date",
    time: "Time",
    paymentAddress: "Expense address",
    instructions: "Expenses statement",
    feeAmount: "Expense amount",
    voucherNumber: "Voucher number",
    requestReceipt: "Request receipt",
    userList: "Cooperate with",
    isBudget: "Budget outlays",
    recipient: "Receive method",
    mState1: "Cash",
    mState2: "E-wallet",
    mState3: "Bank transfer",
    qrcode: "E-wallet QR code",
    myBankAccount: "My bank account number",
    bankInfo: "Account bank information",
    bankAccount: "Payee account",
    bankName: "Payee",
    processList: "Approval process",
    position: "Position",
    username: "User name",
    approvalState: "Approval status",
    aState1: "Unapply",
    aState2: "Pending approval",
    aState3: "Agree",
    aState4: "Disagree",
    approvalResult: "Approval result",
    approvalUser: "Approvel user name",
    opinions: "Approvel opinions",
    auditTime: "Audit time",
    approvalOperate: "Approvel operate",
    agree: "Agree",
    disagree: "Disagree",
    resubmit: "Resubmit",
    saveChange: "Save this change",
    cancelApply: "Cancel this apply",
  },
  financialRequest: {
    paymentRecordNumber: "Payment record number",
    approvalState: "Approval status",
    totalBatch: "Total bacth",
    aState1: "Pending approval",
    aState2: "Completed",
    aState3: "Cancel",
    aState4: "Reject",
    aState5: "Approval completed",
    menthodState: "Payment method",
    mState1: "Cash",
    mState2: "E-wallet",
    mState3: "Bank transfer",
    paymentState: "Payment state",
    pState1: "Unpaid",
    pState2: "Paid",
    supplierName: "Supplier name",
    voucherNumber: "Voucher number",
    recordNumber: "Request record number",
    applicant: "Applicant",
    department: "Department",
    systemCode: "Payment voucher number",
    creditRefNo: "Credit Ref No.",
    costCode: "Cost voucher number",
    submitDate: "Submit Date",
    lastDate: "Latest payment date",
    uploadDate: "Certificate upload date",
    tab1: "Business",
    tab2: "Operate",
    dTitle1: "Supplier and payment information",
    dTitle2: "Cost information",
    requestReceipt: "Request receipt",
    payAmount: "Pay amount",
    payReceipt: "Payment receipt",
    submitTime: "Submit time",
    submitCount: "Submit count",
    costAmount: "Amount of expense",
    costCate: "Expense category",
    button1: "Edit business payment request",
    button2: "Edit operate payment request",
    button3: "Approve business funds",
    button4: "Approve operate funds",
    button5: "View business payment request",
    button6: "View operate payment request",
    payButton: "Pay now",
    txtButton: "Please open www.vtrack.top to complete the payment",
    position: "Position",
    viewButton: "View payment request"
  },
  paymentInvoice: {
    companyName: "Company name",
    payInvoiceNo: "Payment invoice No.",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    warehouseWorkNumber: "Warehouse job number",
    createTime: "Create time",
    invoiceState: "Invoice state",
    state1: "All",
    state2: "Unconfirm",
    state3: "Confirmed",
    submit: "Confirm the bill",
    invoiceNo: "Invoice No.",
  },
  creditedDetails: {
    invoiceNo: "Invoice No.",
    financialAccountNo: "Financial Ref No.",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    warehouseWorkNumber: "Warehouse job number",
    customerName: "Customer number",
    createDate: "Invoice Date",
    nuclearTitle: "Nuclear title",
    receivableAmount: "Receivable Amount",
    payableAmount: "Payable Amount",
    verifyAmount: "Credit Amount",
    blance: "Billing balance",
    billDetail: "Bill Number Details",
    viewCost: "View cost",
    workOrderNumber: "Work order number"
  },
  cargoStatistics: {
    country: "Country",
    destinationCity: "Destination City",
    jobs: "No. of Jobs",
    totalValue: "Total value",
    totalWeight: "Total weight",
    totalCost: "Total Cost",
    totalSell: "Total Selling",
    totalProfit: "Total Profit",
    profitPercent: "Profit Percentage",
  },
  lineChartStatistics: {
    cityName: "City",
    year: "",
    currency: "Currency",
    month: "Month",
    jobs: "No. of Jobs",
    totalValue: "Total value",
    totalWeight: "Total weight",
    airPrice: "Air Freight everage Rate",
    price20: "20' everage Rate",
    price40: "40' everage Rate",
    price40HQ: "40'HQ everage Rate",
    priceOther: "Others everage Rate",
    selectYear: "Select year",
    line1: "Cost price line",
    line2: "Selling price line",
    line3: "Sales",
  },
  expenseStatistics: {
    project: "Project",
    year: "Year",
    totalCost: "Total Cost",
    itemName: "Item name",
    parentName: "Parent category",
    subName: "Sub category",
    amount: "Amount",
    currencySn: "Currency",
    parentNameProportion:
      "The proportion of expenditure of the parent category",
    monthTitle: "Monthly expenditure",
    monthTotal: "Total monthly expenditure",
    selectYear: "Select year",
    selectMonth: "Select month",
    month: "Month",
    monthSn: "Month",
    month1: "January",
    month2: "February",
    month3: "March",
    month4: "April",
    month5: "May",
    month6: "June",
    month7: "July",
    month8: "August",
    month9: "September",
    month10: "October",
    month11: "November",
    month12: "December",
    paymentRecordNumber: "Payment record number",
    category: "Expense subcategory",
    applicant: "Applicant",
    department: "Department",
    submitTime: "Submit time",
    submitCount: "Submit count",
    submitDate: "Submit Date",
    currency: "Currency",
    feeAmount: "Expense amount",
    costCode: "Cost voucher number",
    menthodState: "Payment method",
    mState1: "Cash",
    mState2: "E-wallet",
    mState3: "Bank transfer",
    approvalState: "Approval status",
    aState1: "Pending approval",
    aState2: "Completed",
    aState3: "Cancel",
    aState4: "Reject",
    aState5: "Approval completed",
    paymentState: "Payment state",
    pState1: "Unpaid",
    pState2: "Paid",
    systemCode: "Payment voucher number",
    totalBatch: "Total bacth",
    uploadDate: "Certificate upload date",
    requestReceipt: "Request receipt",
    payReceipt: "Payment receipt",
    fileList: "File list",
  },
  customerBusinessStatistics: {
    customerNumber: "Customer number",
    companyName: "Company name",
    totalVotes: "Total votes",
    tab1: "Customer payment list",
    tab2: "Customer collection list",
    airTotalVotes: "Air total votes",
    seaTotalVotes: "Sea total votes",
    expressTotalVotes: "Express total votes",
    warehouseTotalVotes: "Warehouse total votes",
    amountTitle: "Trade amount",
    payAmount: "Pay amount",
    receivedAmount: "Receive amount",
    amount: "Total amount",
    button1: "Customer payment details",
    button2: "Customer collection details",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    invoiceNo: "Invoice No.",
    financialAccountNo: "Financial Ref No.",
    warehouseWorkNumber: "Warehouse job number",
    createDate: "Invoice Date",
    paidTotal: "Paid Total Amount",
    receivedTotal: "Received Total Amount",
  },
  seaFreightDataStatistics: {
    tab1: "Monthly bill statistics",
    tab2: "Cargo port inquiry",
    month: "Month",
    wayBillCount: "Bill of lading monthly total votes",
    costBillCount: "Total number of votes in the billing month",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    deliveryPort: "Departure port",
    destinationPort: "Arrival port",
    deliveryCity: "Delivery City",
    receiveCity: "Receive city",
    receiveCountry: "Receive country",
    billName: "Bill payment",
    date: "Date",
    cabinet20: "20'",
    cabinet40: "40'",
    cabinet40HQ: "40'HQ",
    cabinetOthers: "Others",
    amountTitle: "Trade amount",
    payAmount: "Payment amount",
    cabinetClass: "Cabinet type class",
    departureDate: "Date of departure",
    arrivalDate: "Date of arrival",
    daysDifference: "Transit days",
  },
  warehouse: {
    warehouseKeeper: "Warehouse keeper",
    warehouseNameOrNumber: "Warehouse name or number",
    warehouseNumber: "Warehouse code",
    warehouseOwnership: "Warehouse ownership",
    warehouseName: "Warehouse name",
    warehouseUseType: "Warehouse use type",
    warehouseAddress: "Warehouse address",
    warehouseContact1: "Contact 1",
    warehouseContact2: "Contact 2",
    warehouseStatus: "Warehouse status",
    disableOption: "Disabled",
    enableOption: "Enabled",
    ownerOption1: "Self-owned warehouse",
    ownerOption2: "Sublet warehouse",
    addButton1: "Create warehouse",
    warehouseLogo: "Warehouse logo",
    warehousePhoto: "Warehouse photos",
    warehouseTime: "Operation time",
    precaution: "Precautions for warehousing",
    warehousePhone: "Contact number",
    warehouseEmail: "Contact Email",
    warehouseOption1: "Warehouse type (single option)",
    warehouseOption2: "Warehouse type (multiple option)",
    ties: "The self-run warehouse can fill in the following information",
    isService: "Services open for public",
    contact: "Contact",
    phone: "Phone",
    photo: "Photo",
    startDate: "Start time",
    endDate: "End time",
    recordNumber: "Form setting record number",
    formName: "Form name",
    object: "Form object",
    editTime: "Modification time",
    editor: "Last modifier",
    formState: "Form state",
    nameOption1: "Warehouse entry notice",
    nameOption2: "Delivery Note",
    remark: "Remark",
    precaution: "Warehouse regulations",
    addButton2: "Create form Settings",
    displayContent: "Display content",
    outboundNumber: "Outbound number",
    outBoundTime: "Out bound time",
    warehousingType: "Warehousing type",
    warehouseWorkNumber: "Warehouse job number",
    warehouseCode: "Warehouse code",
    goodsName: "Goods name",
    billEnterprise: "Billing party",
    createTime: "Store time",
    operation: "Operation",
    boxName: "Box name",
    size: "Size",
    goodsValue: "Item value",
    outBoundState: "Out bound state",
    warehouseNumber: "Warehouse entry No.",
    batch: "Batch",
    InStorageTime: "Warehousing time",
    warehousingTime: "ETA time",
    batchRefNumber: "Good Batch Reference Number",
    criteria: "Goods name/brand/model",
    operateType: "Type of operation",
    operation1: "Warehousing",
    operation2: "Out of warehouse",
    operation3: "Change warehouse",
    addButton3: "Create warehouse order",
    tab1: "Pending for delivery",
    tab2: "Cargo in warehouse",
    tab3: "Cargo operation logs",
    tab4: "Outbound application",
    tab5: "Out of storage",
    pNumber: "Number of packages",
    volume: "Volume",
    weight: "Weight",
    piecesUnit: "Packing unit",
    storageArea: "Storage area",
    storageTime: "Storage date",
    storageDays: "Days of storage",
    logBtn: "More detail",
    goodsNameSn: "Product name",
    brand: "Brand",
    model: "Model",
    exportNumber: "Outbound quantity",
    inventory: "Stock Quantity",
    long: "Long",
    width: "Width",
    height: "Height",
    productImage: "Product pictures",
    status: "Status",
    bContact: "Business contact person",
    bPhone: "Business contact number",
    expressTitle: "Express information",
    expressCompany: "Express company",
    expressNumber: "Delivery Express Ref No.",
    deliveryTitle: "Delivery information",
    emergencyPerson: "Emergency contact person",
    emergencyPhone: "Emergency contact number",
    plate: "Vehicle license",
    cargoTitle: "Cargo information",
    esPackage: "Number of reserved storage items",
    esVolume: "Reserve storage volume",
    esWeight: "Reserve cargo weight",
    adQuantity: "Number of delivery",
    ata: "Actual arrival time",
    incomingVolume: "Volume of goods(Cubic meter)",
    incomingWeight: "Weight of goods(Kilogram)",
    warehousingPhoto: "Warehousing photo",
    arrive: "Arrival confirmation",
    outbound: "Outbound apply",
    viewApply: "View apply",
    sheet1: "Edit express delivery information",
    sheet2: "Edit the delivery information",
    sheet3: "Edit the warehouse work order",
    sheet4: "Debit note",
    sheet5: "Supplier costs",
    sheet6: "Warehouse order detail",
    sheet7: "Details of the outbound work order",
    entrustEnterprise: "Entrusted enterprise of warehousing",
    customerNumber: "Customer number",
    productsName: "Goods name",
    warehouseSn: "Warehouse",
    driverInfo: "Driver information",
    driverName: "Contact person",
    driverPhone: "Contact phone",
    driverPlate: "Vehicle license",
    addProduct: "Create cargo",
    addProductFirst: "Please create cargo first",
    cargoName: "Cargo",
    productsNameSn: "Product name",
    unitPrice: "Unit price",
    quantity: "Total quantity",
    surplus: "Surplus",
    packingDetail: "Packing details",
    pushButton: "Add product",
    caseNumberSn: "Carton No.",
    parentBox: "Parent box number",
    caseNumber: "Carton No. / Pallet number",
    packingQty: "Packing quantity",
    goodsDetail: "Commodity details",
    goodsValueTotal: "Total item value",
    noImage: "No pictures",
    productList: "Product list",
    dialog1: "Please select the product",
    dialog2: "This goods has been packed in boxes",
    dialog3: "Please input the number of boxes",
    dialog4: "The remaining quantity of the packing is insufficient",
    dialog5: "The number of boxes packed is greater than the remaining quantity",
    dialog6: "The product addition is completed",
    dialog7: "The same box cannot be chosen",
    dialog8: "Edit product name",
    dialog9: "Edit product pictures",
    warehouseInfo: "Warehouse info",
    warehouseWorkOrderNumber: "Warehouse work order number",
    warehouseExportNumber: "Outbond job No.",
    date: "Date",
    warehouseStorageName: "Name of the storage warehouse",
    entrustEnterpriseOB: "Entrusted enterprise of outbound",
    enterprise: "Enterprise",
    warehouseData: "Inbound Data",
    meter: "Cubic meter",
    kilo: "Kilogram",
    existingData: "Existing data",
    warehouseDetail: "Inventory details",
    warehouseType: "Warehouse type",
    option1: "Transfer",
    option2: "Out of warehouse",
    onePiece: "One piece shipping",
    selectCargo: "Select the outbound goods",
    goodsExistDetail: "Details of the existing goods",
    selectAll: "Select all",
    parentBoxName: "Parent box name",
    dayOfStorage: "Days of storage",
    updateName: "Update product name",
    updateImage: "Update Image",
    total: "Total",
    productTotal: "Product total",
    outboundTotal: "Outbound total",
    boxTotal: "Box total",
    pickupPerson: "Pick up driver info",
    others: "Others",
    printBtn: "Print out the warehouse receipt",
    printAgainBtn: "Print out the warehouse receipt again",
    inputNumberSearch: "Search warehouse work number",
    days: "Days",
    costTitle: "Cost detail",
    sellTitle: "Sell detail",
    financialAccountNo: "Financial Ref No.",
    customerName: "Customer number",
    billReferNo: "Supplier Billing Reference Number",
    totalPayable: "Total payable",
    viewCost: "View cost",
    deleteCost: "Delete cost",
    subTotal: "Sub-total",
    rate: "Rate",
    totalAmount: "Total Amount",
    invoiceNo: "Invoice No.",
    totalReceive: "Total receivable",
    viewSell: "View sell",
    deleteSell: "Delete sell",
    receTotalAmount: "Total Amount",
    profitTotalAmount: "Total Amount",
    unloadText: "Please input warehouse work number to search",
    notice: "Notice",
    deleteCheck1: "Are you sure to delete this cost?",
    deleteCheck2: "Are you sure to delete this sell?",
    warehousingInfo: "Inbound information",
    productModel: "Product model",
    productBrand: "Product brand",
    numberBoxes: "Number of boxes",
    totalPackingQuantity: "Total packing quantity",
    totalGoodValue: "Total goods value",
    entrustingParty: "Entrusting party",
    stockQueryType: "Stock query type",
    stockQueryType1: "All data",
    stockQueryType2: "Show only data with stock",
    queryTotal1: "Total number of goods categories",
    queryTotal2: "Total number of boxes of goods",
    queryTotal3: "Total value of goods",
    statementTotal1: "Total number of boxes warehoused",
    statementTotal2: "Total quantity warehoused",
    statementTotal3: "Total value warehoused",
    statementTotal4: "Total number of boxes shipped out",
    statementTotal5: "Total quantity shipped out",
    statementTotal6: "Total value shipped out",
    sort: "Sort",
    emailPush: "Email push",
    emailPushTest: "Push test",
    emailSetting: "Email configuration",
    emailLabel: "Push email",
    emailError: "Please configure email settings first",
    sendSetting: "Send frequency",
    sendDate: "Send date",
    sendTime: "Send time",
    configState: "Configuration status",
    daily: "Daily",
    fixedDate: "Fixed date",
    weekly: "Weekly",
    monthly: "Monthly",
    week0: "Sunday",
    week1: "Monday",
    week2: "Tuesday",
    week3: "Wednesday",
    week4: "Thursday",
    week5: "Friday",
    week6: "Saturday",
    emailLanguage: "Email display language",
    emailLanguage1: "Chinese",
    emailLanguage2: "English",
  },
  marketRisk: {
    advertTitle: "Advertisement title",
    advertTypeStr: "Description of Advertising Types",
    advertType: "AD types",
    advertContent: "The contents of advertisements ( locality )",
    advertContentEn: "The contents of advertisements ( English )",
    showType: "Display type",
    moduleType: "Module type",
    moduleStr: "Module",
    lineUrl: "The Url of the external link",
    isShow: "Is show",
    newAdvert: "Create AD",
    all: "All",
    graphic: "Graphic advertising",
    externalLinks: "External links",
    notDisplay: "Not display",
    display: "Display",
    pcStation: "PC",
    wxStation: "mini program",
    linkParam: "Link parameters",
    sort: "Sort",
    imgUrl: "Preview",
    customerNumber: "Customer number",
    customerName: "Customer name",
    country: "Country",
    city: "City",
    lPerson: "Legal person",
    sales: "Sales",
    phone: "Phone number",
    setBlock: "Set restrict",
    closeBlock: "Close restrict",
    newRestrict: "Create directory",
    entrustEnterprise: "Entrusted enterprise of warehousing",
    companyNameEn: "Company name in English",
    companyNameSn: "Company name in short",
    legalPerson: "Company legal person",
    legalPersonPhone: "Legal person phone",
    businessNo: "Business License No",
    salesName: "Sales name",
    salesPhone: "Sales phone number",
    addPeople: "Add By",
    serviceEmail: "Customer service Email",
    contactPhone: "Contact Number",
    wechat: "Wechat id",
    createPush: "Create email push",
    fileQrcode: "File qr code",
    accountQrcode: "Official accounts qr code",
    isEnabled: "Is enable",
  },
  salesManagement: {
    qrNumber: "Quotation reference number",
    qNumber: "Quotation number",
    quoteDate: "Quote date",
    quotePeople: "Quote principal",
    companyName: "Company name",
    businessType: "Business types",
    delivery: "Departure",
    destination: "Arrival",
    supplierName: "Supplier name",
    nickName: "Order issuer phone number",
    sales: "Sales",
    createTime: "Create time",
    state: "State",
    option1: "Quoted",
    option2: "Unquote",
    addQuote: "Create quotation",
    tab1: "Unquote",
    tab2: "Quotation",
    title1: "Customer enquiry details",
    title2: "Goods detail",
    title3: "Quotation detail",
    title4: "Add quotation",
    enterprise: "Enterprise",
    initiationPhone: "Initiator contact number",
    initiationTime: "Create time",
    goodsName: "Goods name",
    tradeTerms: "Trade terms",
    pNumber: "Number of packages",
    volume: "Volume",
    weight: "Weight",
    piecesUnit: "Packing unit",
    volumeUnit: "Volume unit",
    weightUnit: "Weight unit",
    brand: "Brand",
    liquid: "Liquid",
    powder: "Powder",
    magnetic: "Magnetic",
    export1: "Export broker",
    export2: "Export tax rebate",
    export3: "Import",
    commission: "Commission to decalre",
    tdService: "Delivery service",
    takeDeliveryCity: "Country city of delivery",
    takeDeliveryPerson: "Delivery contact name",
    takeDeliveryContactPhone: "Delivery contact phone",
    takeDeliveryAddress: "Delivery address",
    tdLocation: "Delivery place",
    addQuotation: "Add quotation",
    qValidity: "Quote validity",
    qDate: "Quotation date",
    customerNumber: "Customer number",
    deliveryPort: "Departure port",
    destinationPort: "Arrival port",
    exportType: "Quotation type",
    pricing: "Pricing",
    unit: "Unit",
    total: "Total",
    carrier: "Carrier",
    transitTime: "Transit time",
    remark: "Remark",
    polTitle: "Local Charges in POL",
    freightTitle: "Transportation costs",
    podTitle: "Local Charges in POD",
    serviceTitle: "Additional Services Charges",
    inputOrderNumber: "Search entrust order number",
    orderNumber: "Entrust order number",
    erNumber: "Entrusted reference number",
    orderPcState: "Order status",
    createDate: "Create time",
    entrustDetail: "Entrust detail",
    customerInfo: "Customer Information",
    addSop: "Add SOP",
    viewSop: "View SOP",
    orderState: "Order status",
    state1: "Unbuild SOP",
    state2: "Unoperate",
    state3: "Unshippe",
    state4: "Unbill",
    state5: "Uncollect",
    state6: "Finished",
    createButton: "Create entrust order",
    title5: "freight transport order number",
    title6: "Logistics information",
    sales: "Sales",
    entrustDay: "Entrust day",
    shipper: "Shipper",
    consignee: "Consignee",
    notify: "Notify",
    paymentTerms: "Payment terms",
    goodsData: "Goods data",
    sopNumber: "SOP number",
    costTitle: "Cost detail",
    sellTitle: "Sell detail",
    notes: "Operation handover details",
    entrustEnterprise: "Entrusted enterprise of warehousing",
    later: "Input later",
    contactPhone: "Contact number",
    address: "Address",
    email: "Email address",
    same: "Same as notify and consignee",
    deliveryCity: "Delivery City",
    destinationCity: "Destination City",
    entrustType: "Entrust order type",
    costPay: "Cost pay",
    rule: "Business rules and contracts",
    warehouseWorkNumber: "Warehouse job number",
    wbNumber: "Master or House B/L",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    customerId: "Customer number",
    atd: "ATD",
    invoiceNo: "Invoice No.",
    createDate: "Invoice Date",
    billTotal: "Total bill",
    recommend: "Referrer",
    nuType1: "Receivable",
    nuType2: "Payable",
    nuType3: "Balance",
    accoutingTab1: "Receivable Payment",
    accoutingTab2: "Received Payment",
    accoutingTab3: "Profitable",
    kefu: "CS",
    marketing: "Marketing",
    sales: "Sales",
    operation: "Operation",
    tradeTitle: "Trade logistics",
    amountTitle: "Trade amount",
    receivedAmount: "Receive amount",
    receivedTotal: "Received Total Amount",
    payAmount: "Pay amount",
    paidTotal: "Paid Total Amount",
    subProfit: "Sub-total Profit",
    balance: "Recivable Balance",
    totalBalance: "Total balance receivable",
    rate: "Rate",
    nuclearTitle: "Nuclear title",
    nuclearAccountNo: "Processing account record",
    creditDate: "Credit Date",
    shortName: "Short name",
    nuclearType: "Nuclear account type",
    bank: "Bank of transation",
    receivableAmount: "Receivable Amount",
    payerName: "Payer Name",
    outStandingDays: "Out Standing Days",
    creditBalance: "Credit Amount Balance",
    taxInvoice: "Tax invoice",
    invoiceNumber: "Tax invoice No.",
    invoiceFile: "Tax invoice file",
    details: "Details",
    billDetail: "Bill Number Details",
    transportType: "Transport type",
    chargeableWeight: "Chargeable weight",
    warehouseState1: "Unstorage",
    warehouseState2: "Storaged",
    warehouseState3: "Complete",
    createEntrustOrder: "Create entrust order",
    qState: "Quotation status",
    quoteTime: "Quotation time",
    createFreightOrder: "Create freight order",
    goodsNameEn: "English product name",
    billInformation: "Bill of lading information",
    shipperAddress: "Shipper address",
    shipperPhone: "Shipper contact phone",
    shipperEmail: "Shipper email address",
    consigneeAddress: "Consignee address",
    consigneePhone: "Consignee contact phone",
    consigneeEmail: "Consignee email address",
    notifyAddress: "Notifying party address",
    notifyPhone: "Notifying party contact phone",
    notifyEmail: "Notifying party email address",
    supplier: "Supplier",
    warehouseNumber: "Warehouse entry number",
    supplierList: "Supplier list",
    invoice: "Invoice",
    packingList: "Packing list",
    goodState: "Goods status",
    emailShare: "Email share",
    clickShare: "Click to share",
    sendInvite: "Send invitation",
    placeholderEmail: "Input multiple emails separated by ','",
    workInquiryNumber: "Waybill number",
    bookingNumber: "Main waybill number",
    subTotal: "Sub-total",
    unreceiveTotal: "Unreceive total",
    orderCustomer: "Order customer",
  },
  supplier: {
    addTitle: "Added quotes for overseas agency services",
    editTitle: "Edit overseas agency service quotation",
    quotationCollection: "Quotation list",
    minimumUnit: "Minimum charge unit",
    minimum: "Minimum charge",
    denistyRatio: "Denisty ratio",
    sectionCharge: "Fee range",
    awWay: "Access path",
    collection: "Collection project",
    createQuote: "Create quotation",
    shipperCompany: "Shipper Company",
    dealCount: "Number of transactions in the past 12 months",
    costRecord: "Cost record number",
    companySn: "Company name",
    code: "Port of offer",
    bcType: "Business type",
    unitPrice: "Unit price",
    unitPriceCharge: "Unit charge unit",
    address: "Address",
    section: "Section",
    contact: "Contact",
    contactPhone: "Contact phone",
    notes: "Operation Notes",
    email: "Email",
    area: "Area",
    country: "Country",
    city: "City",
    companyName: "Company name",
    contactName: "Contact name",
    phoneNumber: "Phone number",
    wechat: "Wechat ID",
    referrer: "Referrer",
    lastDate: "Last updated",
    cooperate: "Number of cooperation",
    serviceArea: "Service area",
    serviceCate: "Service category",
    serviceCountry: "Service country",
    operatingProducts: "Operating product",
    businessClass: "Service classification",
    serviceContent: "Service content",
    serviceDetail: "Service content detail",
    regulatory: "Regulatory category",
    warehouseCate: "Warehouse category",
    danger: "Dangerous goods storage registration",
    vehicleNum: "Number of vehicles",
    vehicleCate: "Vehicle class",
    vehicleType: "Vehicle type",
    carrier: "Carrier",
    mainBusiness: "Main business",
    exportCate: "Import and export category",
    wbType1: "Air Freight / Air To Door",
    wbType2: "Sea Freight / Sea To Door",
    wbType3: "Express",
    wbType4: "Railway transport",
    export1: "Export",
    export2: "Import",
    business1: "Air Freight First",
    business2: "Charter service",
    business3: "Sea Freight booking",
    business4: "Special container",
    business5: "Service agent",
    area1: "In city",
    area2: "In province",
    area3: "In country",
    area4: "Macao",
    area5: "Hong Kong",
    car1: "Ordinary vehicle",
    car2: "Supervision vehicle",
    car3: "Transit vehicle",
    car4: "Refrigerator car",
    weight1: "3 ton",
    weight2: "5 ton",
    weight3: "8 ton",
    weight4: "10 ton",
    weight5: "12 ton",
    weight6: "18 ton",
    weight7: "Trailer",
    weight8: "Boom truck",
    weight9: "Flat car",
    serveWarehouse1: "Domestic storage",
    serveWarehouse2: "Hong Kong, Macao and Taiwan storage",
    serveWarehouse3: "Foreign storage",
    superviseWarehouse1: "Ordinary warehouse",
    superviseWarehouse2: "Bonded warehouse",
    superviseWarehouse3: "Supervised Warehouse",
    superviseWarehouse4: "FBA overseas warehouse",
    typeWarehouse1: "Outdoor flat",
    typeWarehouse2: "Indoor warehouse",
    typeWarehouse3: "Container yard",
    typeWarehouse4: "Ground",
    typeWarehouse5: "Ordinary indoor storage",
    typeWarehouse6: "E-commerce sorting warehouse",
    typeWarehouse7: "Constant temperature storage",
    typeWarehouse8: "Refrigerated storage",
    typeWarehouse9: "Dangerous goods warehouse",
    service1: "Customs declaration",
    service2: "Trade agency",
    service3: "Packaging and materials",
    service4: "Freight insurance",
    service5: "Port service",
    service6: "Inspection survey",
    service7: "Freight law",
    tab1: "Supplier transport service",
    tab2: "Supplier motor transport services",
    tab3: "Supplier warehousing services",
    tab4: "Supplier value-added supporting services",
  },
  enterpriseLogistics: {
    searchText1: "Product name / brand / model",
    searchText2: "Name / Phone number",
    assetClassName: "Asset class name",
    accountName: "Account name",
    accountNumber: "Account number",
    setMealConfig: "Set meal config",
    loginPassword: "Login password",
    accountLocation: "Account location",
    assetState: "Asset status",
    aState1: "in store",
    aState2: "lend out",
    aState3: "return",
    goodsName: "Product name",
    goodsModel: "Product model",
    goodsBrand: "Product brand",
    goodsConfig: "Product config",
    goodsSize: "Product size",
    goodsArea: "Product area",
    goodsAddress: "Product address",
    purchaseDate: "Date of purchase",
    openingDate: "Account opening date",
    handoverDate: "Handover date",
    purchaseAmount: "Amount of purchase",
    handoverRecord: "Service handover record",
    assetType: "Asset type",
    addClass: "Create category",
    className: "Class name",
    fixedAssets: "Fixed assets",
    digitalAssets: "Digital assets",
    createAssets: "Create assets",
    editAssets: "Edit assets",
    addAssets: "Add assets",
    fileList: "Asset file list",
    class: "Class",
    photo: "Photo",
    incharge: "Incharge",
    customerNumber: "Customer Number",
    surname: "Name",
    position: "Position",
    gender: "Gender",
    male: "Male",
    female: "Female",
    phoneNumber: "Phone number",
    nativePlace: "Native place",
    education: "Education",
    entryState: "Entry state",
    employment: "Employ",
    dimission: "Dimission",
    entryDate: "Date on board",
    resignationDate: "Date on departure",
    employeeResign: "Employee resign",
    listOrderBy: "Sort",
    orderBy1: "Sort information by time of entry",
    orderBy2: "Sort by date of entry",
    orderBy3: "Sort by date of departure",
  },
  currencySettings: {
    searchText: "Currency or CurrencySn",
    addButton: "Create currency",
    currency: "Currency",
    currencySn: "Currency short name",
    currencySymbol: "Currency symbol",
    useState: "Use of state",
    settlement: "Settlement currency",
    setCurrency: "Set the settlement currency",
  },
  invoiceTitle: {
    titleType: "Title type",
    unit: "Unit",
    taxNumber: "Company tax number",
    address: "Company address",
    phone: "Company phone number",
    bankName: "Bank name",
    bankAccount: "Bank account",
    alert:
      "The company title and the company tax number are not allowed to be modified after the addition. If the modification is made, please submit an application or contact the customer service directly for modification",
  },
  consumptionRecord: {
    allOrderNumber: "All order number",
    cOrderNumber: "Order number",
    orderType: "Order type",
    orderState: "Order status",
    paymentState: "Payment type",
    totalAmount: "Total order amount",
    payAmount: "Pay amount",
    orderTime: "Order time",
    actualDate: "Order payment time",
    methods: "Method of payment",
    typeOption1: "Start using",
    typeOption2: "Extension",
    typeOption3: "Renewal",
    stateOption1: "Unpaid",
    stateOption2: "Paid",
    stateOption3: "Expire",
    paymentOption1: "Wechat",
    paymentOption2: "Alipay",
    paymentOption3: "Public account",
    paymentTitle: "Please transfer the money to the following account",
    bankName: "Bank name",
    bankAccount: "Bank account",
    hotline: "Hot line",
    gotoPay: "Pay"
  },
  financialAuditProcessSettings: {
    tab1: "Business cost audit",
    tab2: "Operating expense audit",
    auditor: "Auditor",
    level: "Level",
    job: "Job title",
    charge: "Person in charge",
    cashier: "Cashier",
  },
  getWayBillOperationLog: {
    searchText1: "operation number",
    searchText2: "payment inquiry / serial registration number",
    tab1: "Way bill number logs",
    tab2: "Entry bill logs",
    log: "Operation logs",
    content: "Operation content",
    inquiryNumber: "Payment inquiry number",
    srNumber: "Serial registration number",
    date: "Operation date",
    username: "Operator",
  },
  expenseCategorySettings: {
    project: "Project",
    name: "Category name",
    category: "Expense subcategory",
    parent: "Parent category",
    addTitle: "Create expense category",
    editTitle: "Edit expense category",
    addButton: "Create expense category"
  },
  userList: {
    searchText: "User name / Phone number",
    avatar: "Avatar",
    username: "User name",
    createTime: "Registration Time",
    contactNumber: "Contact number",
    phone: "Phone number",
    email: "Email",
    parentUserName: "Department manager",
    password: "Password",
    userState: "User Status",
    roleName: "User role",
    parentName: "Superior",
    freeze: "Freeze",
    thaw: "Thaw",
    status: "Status",
    option1: "Normal",
    option2: "Unfrozen",
    addUser: "Add User",
    verifyCode: "VerifiyCode",
    get: "Send",
    assignRole: "Assign roles",
    role: "Role name",
    deleteText: "Are you sure to delete this user?",
    selectRole: "Please select a role",
    selectUser: "Please select a user",
  },
  roleList: {
    role: "Role name",
    editRole: "Edit role",
    addRole: "Create role",
    isSuper: "Set the supervisor role",
    dialogText: "Are you sure to delete this role?",
    setRight: "Set right",
    searchText: "Search role name",
    roleClass: "Character classification",
    manager: "Manager",
    distributor: "Distributor"
  },
  store: {
    companyName: "Company name",
    companyAccount: "Company account",
    remind: "Remain account",
    vpDate: "Package expire date",
    unpaidText: "You have an order pending payment",
    onPay: "Go to pay",
    back: "Back",
    isBuy: "Purchased",
    accountNumber(val) {
      return "Account number (" + val + "¥/account)";
    },
    accountLanguage(val) {
      return "System multi-language (" + val + "¥)";
    },
    accountWxMini(val) {
      return "Wechat mini program (" + val + "¥)";
    },
    validityDate: "Period of validity",
    cutoff: "Expire date after",
    menusLabel: "Package choice (multiple options)",
    coupon: "Coupon",
    payCurrency: "Payment currency",
    methods: "Method of payment",
    totalAmount: "Total amount",
    discountAmount: "Discount amount",
    payAmount: "Pay amount",
    agreementText: "I have read and agree to the Vtrack Service Agreement",
    orderButton: "Order now",
    stepOption1: "Start using",
    stepOption2: "Extension",
    stepOption3: "Renewal",
    ruleIsAgree: "Please check the service agreement",
    paymentOption1: "Wechat",
    paymentOption2: "Alipay",
    paymentOption3: "Offline payment",
    expire: "Expired",
    year: " Year",
    guideText: "Please click the business you want to operate",
  },
  clientFund: {
    serialRegistrationNumber: "Serial registration number",
    creditRefNo: "Credit Ref No.",
    exchangeNo: "Exchange No.",
    fundClass: "Fund class",
    paymentType1: "Business charges",
    paymentType2: "Operating charges",
    accountName: "Account name",
    remitterName: "Remitter name",
    remittanceLocation: "Remittance location",
    remittanceAmount: "Remittance amount",
    remittanceCurrency: "Remittance currency",
    bankCharges: "Bank charges",
    bankChargesCurrency: "Bank charges currency",
    customerNumber: "Customer number",
    customerName: "Customer name",
    companyName: "Company name",
    receivedAmount: "Receive amount",
    receivedCurrency: "Receive currency",
    transferDate: "Transfer date",
    bankAccount: "Bank account",
    minAmount: "Min",
    maxAmount: "Max",
    inquiryNumber: "Payment inquiry number",
    paymentTradeNumber: "Payment transaction number",
    fillInDate: "Filling date",
    receiveDate: "Receive date",
    entryType: "Entry type",
    type1: "Finance",
    type2: "Business",
    entryState: "Entry state",
    entryState1: "Unsettle",
    entryState2: "Settled",
    entryState3: "Deleted",
    remark: "Remark",
    agent: "Agent",
    entryFile: "Entry file",
    dic1: "Unreceive amount",
    dic2: "Unreceive total amount",
    dic3: "Credit amount",
    dic4: "Credit amount total",
    clientFundUse: "Client fund use detail",
    clientFundData: "Unreceive total",
    sort: "Order b",
    fundType: "Fund Type",
    fdType1: "Income",
    fdType2: "Expenditure",
    fdType3: "Exchange income",
    fdType4: "Exchange expenditure",
    fdType5: "Write off",
    operateDate: "Operate date",
    bookCurrency: "Currency",
    bookAmount: "Book keeping amount",
    originBalance: "Original account balance",
    bookBalance: "Book keeping account balance",
    username: "Operate user",
    writeOff1: "Write off currency",
    writeOff2: "Write off amount",
    writeOff3: "Write off remark",
    useButton1: "Client fund transfer detail",
    useButton2: "Credited details",
    useButton3: "Client fund exchange record",
    exchangeCurrency: "Exchange currency",
    exchangeAmount: "Exchange amount",
    exchangeBeforeBalance: "Before exchange balance",
    exchangeAfterBalance: "After exchange balance",
    convertBeforeBalance: "Before convert balance",
    convertAfterBalance: "After convert balance",
    rate: "Exchange rate",
    fromCurrecny: "Currency to be exchange",
    toCurrency: "Currency you need to change",
    toAmount: "After amount",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    invoiceNo: "Invoice No.",
    warehouseWorkNumber: "Warehouse job number",
    createDate: "Create date",
    beforeBlance: "Available balance",
    afterBlance: "After exchange",
    frozenBalance: "Frozen balance",
    amountStatistics: "Amount statistics",
    dateStatistics: "Date statistics",
    createTime: "Create date",
    customer: "Customer",
    fileList: "File list",
    file: "File",
    businessTitle1: "View client fund business entry",
    businessTitle2: "Edit client fund business entry",
    businessTitle3: "Add client fund business entry",
    businessAddButton: "Create client fund business entry",
    fundsTransferCustomerNumber: "Funds transfer customer number",
    fundsTransferCustomerName: "Funds transfer customer name",
    transferUserName: "Transfer user name",
    financeTitle1: "View client fund finance entry",
    financeTitle2: "Edit client fund finance entry",
    financeTitle3: "Add client fund finance entry",
    financeAddButton: "Create client fund finance entry",
    transfer1: "Client fund transfer",
    transfer2: "Confirm",
    transfer3: "Cancel",
    transferNotice: "Please select the same remitter for transfer",
    customerNotice: "Finance confirm the entry of customer account below, or click to modify customer account",
    clickNotice: "Select the business entry bill",
    selectBill1: "Please select the business entry bill",
    selectBill2: "Please select the finance entry bill",
    exchange: "Exchange",
    writeOff: "Write off",
    all: "All",
    currencyError: "The same currency cannot be chosen",
    excess: "Excess of available balance",
    applicant: "Applicant",
  },
  buildWayBillNo: {
    kefu: "CS",
    marketing: "Marketing",
    sales: "Sales",
    operation: "Operation",
    shippingDetail: "Shipping Details",
    shipperCompany: "Shipper's company",
    address: "Address",
    country: "Country",
    destination: "Destination details",
    consigneeCompany: "Consignee company",
    phone: "Phone number",
    postalCode: "Postal code",
    trackNumberDetails: "Track number details",
    productName: "Product name",
    customsCode: "Customs code",
    weight: "Weight",
    numberBoxes: "Number of boxes",
    boxUnit: "Box Unit",
    volume: "Volume",
    value: "Item Price",
    currency: "Curreny",
    others: "Others",
    tradingPlatform: "Trading platform",
    remark: "Remark",
    totalData: "Total data",
    totalWeight: "Total weight",
    totalCases: "Total number of cases",
    contactError: "The company has no contact person",
    selectUser: "Please select a user",
    selectDate: "Please select a date",
    wbNumber: "Master or House B/L",
    wbNumberData: "Load the master or House B/L data",
    totalCargoQuantity: "Total cargo quantity",
    cargoQuantity: "Items quantity",
    searchCustomsCode: "Search customs code",
    searchCommodityCode: "Search commodity code",
    customsCommodityCode: "Customs commodity code",
  },
  antiMoneyLaundering: {
    title1: "Anti-money laundering list inquiry",
    title2: "Anti-money laundering detail",
    search: "Search",
    antiSearch: "Anti-money laundering inquiry",
    name: "Name",
    address: "Address",
    identityNum: "Id number",
    bic: "BIC code",
    country: "Country/area",
    narrative: "Narrative",
    swift: "swift message",
    tshpzh: "Business number",
    caseId: "Warning number",
    attribute: "List attribute",
    qPeople: "Search by",
    qDate: "Search date",
    antiOption1: "Normal",
    antiOption2: "Sanctions",
    queryResult: "Search result",
    antiView: "Warning view",
    dialogQueryTitle: "This information has been queried within 30 days, do you need to query again?",
  },
  platformOrders: {
    tab1: "Order list",
    tab2: "Manifest list",
    orderCustomerinvoicecode: "Order number",
    wbNumber: "Waybill number",
    paymenttypeCode: "Payment code",
    paymentType: "Payment type",
    boxNo: "Box number",
    mawb: "Main order No.",
    weight: "Weight",
    volume: "Volume",
    totalValue: "Total value",
    totalWeight: "Total G.W.",
    orderPiece: "Number of pieces",
    referenceNo: "Ref No.",
    packageNo: "Pack No.",
    orderDate: "Order date",
    createTime: "Create time",
    expectedDeliveryDate: "Pre-arrival date",
    consigneeOrShipperName: "Consignee/Shipper name",
    consigneeOrShipperCompanyName: "Consignee/Shipper company name",
    consigneeOrShipperPhone: "Consignee/Shipper phone number",
    consigneeName: "Consignee name",
    consigneeCompanyname: "Consignee company name",
    consigneeTelephone: "Consignee phone number",
    consigneeMobile: "Consignee phone number",
    consigneeAddress: "Consignee address",
    consigneeCountry: "Consignee country",
    consigneeCity: "Consignee city",
    consigneeCountryCity: "Consignee country/city",
    consigneeState: "Consignee province",
    consigneePostcode: "Consignee postcode",
    consigneePassportno: "Consignee passport number",
    consigneeEmail: "Consignee email",
    consigneeTaxno: "Consignee tax number",
    shipperName: "Shipper name",
    shipperCompanyname: "Shipper company name",
    shipperTelephone: "Shipper phone number",
    shipperPhone: "Shipper phone number",
    shipperAddress: "Shipper address",
    shipperCountry: "Shipper country",
    shipperState: "Shipper province",
    shipperCity: "Shipper city",
    shipperPostcode: "Shipper postcode",
    shipperPassportno: "Shipper passport number",
    shipperEmail: "Shipper email",
    shipperTaxnotype: "Tax number type",
    shipperTaxno: "Shipper tax number",
    shipperTaxnocountry: "Shipper tax number country",
    orderCodamount: "COD amount",
    orderCodcurrency: "COD currency",
    chargeableWeight: "Chargeable weight",
    codOrNonCod: "Is it cod",
    itemDescEn: "Goods Description in English",
    itemQuantity: "Quantity of goods",
    declareValue: "Declared value",
    declareValueCurrency: "Declared value currency",
    label1: "Order information",
    label2: "Consignee information",
    label3: "Shipper information",
    label4: "Importer information",
    label5: "Order products",
    customerinvoicecode: "Original order Number of the customer / Ref No.",
    orderReturnsign: "Return sign",
    tradeType: "Trade type",
    orderTransactionurl: "Product sales address",
    orderCargoamount: "Order goods amount",
    orderInsurance: "Insurance amount",
    cargoType: "Package type",
    importCode: "Importer code",
    importName: "Importer name",
    importCompanyname: "Name of the importer company",
    importAddress: "Importer's Address",
    importTelephone: "Importer's phone number",
    importEmail: "Importer's email",
    importPostcode: "Postal code of the importer",
    importCountry: "Importer's country",
    importState: "Importer's province",
    importCity: "Importer city",
    invoiceAmount: "Declared total value",
    invoiceCurrency: "Declared currency",
    invoiceTitle: "English product name",
    sku: "Chinese product name",
    skuCode: "Distribution information",
    hsCode: "HS Code",
    invoicePcs: "Number of pieces",
    invoiceWeight: "Single-piece weight",
    invoiceVolume: "Single-piece volume",
    volumeHeight: "Height",
    volumeLength: "Long",
    volumeWidth: "Width",
    volumeWeight: "Actual weight",
    transactionUrl: "Sales address",
    invoiceunitCode: "Report unit",
    invoiceImgurl: "Picture address",
    noImage: "No pictures",
    invoiceBrand: "Brand",
    invoiceRule: "Specification",
    invoiceTaxno: "Tariff number",
    originCountry: "Country of origin",
    invoiceMaterial: "Material",
    invoicePurpose: "Purpose"
  },
  vehicles: {
    vin: "Vehicle identification number",
    plate: "Vehicle license",
    brand: "Brand",
    model: "Model",
    color: "Color",
    length: "Vehicle Length (meters)",
    width: "Vehicle width (meters)",
    height: "Vehicle heigth（meters）",
    vehicleType: "Vehicle type",
    vehiclePhoto: "Vehicle photo",
    dimensions: "Vehicle dimensions",
    maxLoad: "Maximum load（kg）",
    vehicleStatus: "Vehicle status",
    vStatus1: "in use",
    vStatus2: "maintain",
    vStatus3: "deactivate",
    vStatus4: "Scrap",
    addVehicle: "Create vehicle",
    editVehicle: "Edit vehicle",
    updateVehicleStatus: "Update vehicle status",
    sheetNotice: "Please select the vehicle first",
  },
  expressEmployee: {
    addEmployeeRole: "Create new employee information",
    editEmployeeRole: "Edit employee",
    employeeRole: "Employee role",
    role1: "Driver",
    role2: "Deliverer",
    role3: "Warehouse keeper",
    surname: "Name",
    male: "Male",
    female: "Female",
    gender: "Gender",
    nationality: "Nationality",
    birthDate: "Birth date",
    idCardNumber: "Identity card number",
    idCardAddress: "Identity card address",
    currentAddress: "Current address",
    phoneNumber: "Phone number",
    alternatePhone: "Alternate phone",
    email: "Email",
    emergencyContact: "Emergency contact person",
    emergencyPhone: "Emergency contact number",
    addUser: "Add user",
    createTime: "Create time",
    accountActivate: "Account activation",
    aStatus1: "Inactive",
    aStatus2: "Activated",
    accountLock: "Account lock",
    lStatus1: "Normal",
    lStatus2: "Locked",
    createButton: "Create employee",
    lockButton: "Lock",
    unlockButton: "Unlock",
    avatarPhoto: "Avatar photo",
  },
  cargoWarehousing: {
    returnWarehouse: "Return to warehouse",
    exceptionHandling: "Exception handling",
    exceptionReason: "Exception reason",
    deliveryExceptionReason: "Delivery exception reason",
    exceptionNotice: "Reassign warn",
    exceptionText(val) {
      return "The reassign operation is supported up to 3 times at most. You can also operate " + val + " times";
    },
    exceptionAddress: "Shipping address",
    exceptionTrim: "The maximum number of reassign is three times",
    transferDeliveryCount: "Reassign time",
    eState1: "Reassign",
    eState2: "Return to warehouse",
    tab1: "Pending for delivery",
    tab2: "Cargo in warehouse",
    tab3: "Outbound list",
    tab4: "Exception cargo",
    label1: "Order information",
    label2: "Consignee information",
    label3: "Driver delivery information",
    label4: "Warehouse information",
    label5: "Delivery information",
    label6: "Details of the goods",
    outboundBatch: "Outbound batch",
    warehouseEntryNumber: "Warehouse entry number",
    wbNumber: "Master or House B/L",
    mainWbNumber: "Master B/L",
    sideWbNumber: "House B/L",
    totalNumber: "Total No.of Packing",
    totalWeight: "Total G.W.",
    totalValue: "Total Vol",
    isCodorder: "Cod order",
    consignee: "Consignee",
    consigneePhone: "Consignee phone number",
    consigneeAddress: "Consignee address",
    pod: "POD",
    headPhoto: "Driver avatar",
    noImage: "No pictures",
    driver: "Driver",
    driverName: "Driver name",
    driverOrStorageName: "Driver or warehouse keeper name",
    driverDeliveryState: "Driver delivery status",
    dState1: "Undelivered",
    dState2: "Delivery in progress",
    dState3: "Delivered",
    phoneNumber: "Driver phone number",
    vehicle: "Vehicle",
    vehiclePhoto: "Vehicle photo",
    licensePlate: "Delivery plate number",
    color: "Color",
    cargoReceivedPhoto: "Cargo received photo",
    cargoArrivalPhoto: "Cargo arrival photo",
    uploadTime: "Upload time",
    warehouse: "Warehouse",
    warehouseCode: "Warehouse code",
    warehouseName: "Warehouse name",
    warehouseAddress: "Warehouse address",
    storageHeadPhoto: "Warehouse worker avatar",
    storageName: "Warehouse worker name",
    storagePhoneNumber: "Warehouse worker phone number",
    warehouseKeeper: "Warehouse keeper",
    cargoWarehousingTime: "Cargo warehousing time",
    applyOutboundTime: "Outbound time",
    outboundTypeLabel: "Outbound type",
    outboundType1: "Out of warehouse",
    outboundType2: "Transfer",
    deliverer: "Deliverer",
    deliveryPersonHeadPhoto: "Deliverer avatar",
    deliveryPersonName: "Deliverer name",
    deliveryPersonPhoneNumber: "Deliverer phone number",
    deliveryTime: "Delivery time",
    completionTime: "Completion time",
    goodsName: "Goods name",
    hsCode: "HS Code",
    orderPiece: "Number of pieces",
    weight: "Weight",
    volume: "Volume",
    goodsValue: "Item value",
    outBoundState: "Out bound state",
    obState1: "Pending for outbound",
    obState2: "Delivery in progress",
    obState3: "Completed",
    obState4: "Pending for return",
    applyOutbound: "Apply outbound",
    editOutbound: "Edit outbound batch",
    viewTitle: "View express cargo warehousing",
    editTitle: "Edit express cargo warehousing",
    submitNotice1: "The current operation will cause the unselected waybill number to be returned from the warehouse. Do you want to continue?",
    submitNotice2: "The current operation will delete the unchecked waybill number. Do you want to continue?",
    mawbNumber: "The number of large boxes",
    username: "Operator",
    createTime: "Operation time",
    exception1: "Exception handling",
    exception2: "Exception record",
    postcode: "Postcode",
    receivingName: "Consignee",
    contactPhone: "Contact No.",
    country: "Country",
    city: "City",
    receivingAddress: "Delivery address details",
  },
  onlineOrder: {
    quotationNo: "Quotation Number/Product name",
    shippingProductName: "Name of Shipping product",
    warehouseSearch: "Warehouse name/code",
    warehouseCode: "Warehouse code",
    warehouseName: "Warehouse name",
    warehouseAddress: "Warehouse address",
    warehouseStatus: "Warehouse status",
    warehouseContact1: "Contact 1",
    warehouseContact2: "Contact 2",
    warehousePhone: "Contact number",
    warehouseEmail: "Contact Email",
    warehouseTime: "Operation time",
    warehouseGoods: "Goods warehouse",
    companyName: "Company name",
    companyIcon: "Company logo",
    contact: "Contact",
    state: "State",
    quoUpdateTime: "Quotation update date",
    bjNumber: "Quotation number",
    username: "Update user",
    countryName: "Country name",
    countryFlag: "National flag",
    addPeople: "Add By",
    createTime: "Create time",
    updateTime: "Updated date",
    disableOption: "Disabled",
    enableOption: "Enabled",
    addTitle1: "Create freight price",
    editTitle1: "Edit freight price",
    viewTitle1: "View freight price",
    addTitle2: "Create warehouse information",
    editTitle2: "Edit warehouse information",
    addTitle3: "Create quote information",
    editTitle3: "Edit quote information",
    addTitle4: "Create supplier quotation",
    editTitle4: "Edit supplier quotation",
    stepper1: "Quotation details",
    stepper2: "Freight price details",
    firstTab: "Express Freight management",
    secondTab: "Warehouse management",
    thirdTab: "Vancheen Quotation management",
    fourthTab: "Overseas cross-border customs clearance services",
    attribute: "Attributes of goods not accepted",
    liquid: "Liquid",
    powder: "Powder",
    paste: "Paste",
    charged: "Charged",
    magnetic: "Magnetic",
    unlimited: "Unlimited",
    arrivalCountry: "Arrival country",
    firstWeightPrice: "First weight price",
    continuePrice: "Continue weight price",
    firstEachWeight: "First weight per kilogram",
    firstWeight: "First weight(KG)",
    continueWeightPrice: "Continued weight per kilogram",
    continueWeight: "Continued weight(KG)",
    arriveDay: "Arrive Day",
    cargoCategory: "Transport service in chinese",
    cargoCategoryEn: "Transport service in english",
    transportTime: "Transport time(day)",
    cargoCategorySn: "Transport service",
    postNumber: "Post number",
    goodsName: "Goods name",
    cargoTrackingNumber: "Cargo tracking number",
    customerNumber: "Customer number",
    customerName: "Customer Name",
    storageTime: "Storage date",
    numberPackages: "Number of packages",
    numberPackagesSn: "Packages",
    volume: "Volume",
    weight: "Weight",
    weightUnit: "Weight unit",
    numberBoxes: "Number of boxes",
    numberBoxesOrder: "Number of boxes ordered by the customer",
    chargeableWeight: "Chargeable weight",
    noImage: "No pictures",
    outbound: "Outbound shipment",
    tab1: "Logistics station platform",
    wbNumber: "Waybill number",
    departureDate: "Date of departure",
    logisticsState: "Logistics status",
    countryCode: "Country of destination",
    country: "Country of destination",
    goodState: "Cargo status",
    state1: "In transit",
    state2: "Wait for pick up",
    state3: "Wait for delivery",
    state4: "Completed",
    deliveryMethod: "Delivery method",
    takeDeliveryType1: "Pick up at warehouse",
    takeDeliveryType2: "Apply for delivery",
    pickUpCode: "Pick up code",
    completionTime: "Signature date",
    orderDate: "Order date",
    consigneeName: "Consignee name",
    receiveCustomer: "Consignee name",
    receivePhone: "Consignee's phone number",
    receiveAddress: "Consignee's address",
    phoneNumber: "Phone number",
    receivingAddress: "Receiving address",
    putInStorage: "Put in storge",
    dialogTitle: "Customer order put in storage",
    remark: "Remark in chinese",
    remarkEn: "Remark in english",
    logoImg: "Logo",
    cargoQuantity: "Items quantity",
    goodsValue: "Value of goods",
    isUnpack: "Is the package to be unpacked?",
    generateWaybill: "Generate the waybill number",
    generateExpress: "Generate the express delivery waybill",
    conversionFactor: "Volumetric weight coefficient",
    faceSheet: "Face sheet",
    setPrice: "Set price",
    viewPrice: "View freight price",
    discountRate: "Discount rate",
    addPrice: "Create discount",
    editPrice: "Edit discount",
    serviceProvider: "Service provider",
    productCode: "Product code",
    dialogBillingTitle1: "Please input charging information",
    dialogBillingTitle2: "Please confirm the billing details",
    dialogBillingTitle3: "Please complete the information of the service provider",
    length: "Length",
    width: "Width",
    height: "Height",
    weight: "Weight",
    prevStep: "Previous step",
    nextStep: "Next step",
    firstWeightSn: "First weight",
    continueWeightSn: "Continued weight",
    totalFreight: "Total freight",
    declareValue: "Declared value",
    declareValueCurrency: "Declared value currency",
    deliveryZipCode: "Shipper's postal code",
    naqel_ShippingDateTime: "Shipping date and time",
    naqel_DescriptionOfGoods: "Description of goods",
    naqel_NumberOfPieces: "Number of pieces",
    iMile_PackageTotalVolume: "Total package volume",
    iMile_PackageGrossWeight: "Package gross weight",
    iMile_PackageTotalCount: "Total number of packages",
    iMile_PackageGoodsType: "Package goods type",
    itemsTitle: "Goods details",
    customsCurrency: "Declared currency",
    hsCode: "Hs code",
    batchPrice: "Batch add discounts",
    discountType: "Discount Type",
    discountType1: "Percentage",
    discountType2: "Fixed amount",
    discountRate: "Discount rate",
    discountAmount: "Discount amount",
    scanTitle1: "Scan the post number",
    scanTitle2: "Scan the waybill number",
    setPointRule: "Points rules",
    addRule: "Create points rule",
    deleteRule: "Delete points rule",
    viewRuleHistory: "View points rule history",
    pointsObtainConditions: "Points obtain conditions",
    pointsIncome: "Points income",
    reducedPointsIncome: "Reduced points income",
    ruleDate: "Disposal date",
    supplier: "Supplier",
    area: "Area",
    bcType: "Business type",
    awWay: "Access path",
    updateTime: "Updated date",
    companyNameKeyword: "Supplier name keyword",
    serviceState: "Quotation status",
    serviceState1: "Enable",
    serviceState2: "Disable",
    vatRate: "VAT rate",
    minVatAmount: "Minimum VAT amount",
    minVatCurrency: "Minimum VAT currency",
    customsDutyRate: "Customs duty rate",
    minCustomsDutyAmount: "Minimum customs duty amount",
    minCustomsDutyCurrency: "Minimum customs duty currency",
    highValueFee: "High value fee",
    highValueFeeCurrency: "High value fee currency",
    productTaxRateList: "Product tax rate List",
    productCategory: "Product category",
    taxFeebearingParty: "Tax payer",
    shipperSn: "Shipper",
    consigneeSn: "Consignee",
    totalQty: "Total quantity",
    unpackTitle: "Customer order unpack",
    unpackButton: "Unpack",
    unpackQty: "Unpack quantity",
    packageSn: "Package",
    taxTotal: "Taxes",
    taxStep: "Tax calculation steps",
    isTaxFeebearingPartyInconsistent: "Attention : In the order you selected, the parties responsible for paying taxes are not uniform. If you proceed with the current combination, the system will default that all taxes will be borne by the shipper. If you need to make a change, please adjust the order combination.",
    dialogSheetTitle: "printing options",
    isPrintVtrackLabel1: "Printed distributor label",
    isPrintVtrackLabel2: "Printed vtrack label",
    totalWeight: "Total cargo weight",
    storageOverdueDays: "Storage overdue days",
    shipmentCount: "Number of master bills of lading",
    billCount: "Number of house bills of lading",
    conatiner20: "20-foot container",
    conatiner40: "40-foot container",
    conatiner40HQ: "40HQ container",
    cifGoodsValue: "CIF cargo value (USD)",
    piecesNumber: "Number of pieces",
    supplierName: "Supplier name",
    notes: "Operation notes",
    chargeItems: "Charge items",
    section: "Section",
    billName: "Bill name",
    chargingUnit: "Charging unit",
    minChargingPrice: "Minimum charging price",
    unitPrice: "Unit price",
    isMandatoryItem: "is it mandatory item",
    mandatory1: "Mandatory",
    mandatory2: "Charged upon delivery",
    mandatory3: "Reimbursed based on actual expenses per order",
    costPrice: "Cost price",
    profitPrice: "Profit price",
    salesPrice: "Sales price",
    calculatePrice: "Calculate fee",
    calculateDetail: "Calculation details",
    chargingCurrency: "Charging currency",
    oCurrency: "Original currency",
    dCurrnecy: "Display currency",
    isCustomsInspection: "Is customs inspection",
    isChargeUponDelivery: "Is includes charged upon delivery",
    isCostReimbursement: "Is includes reimbursement based on actual expenses per order",
    totalCost: "Total cost",
    totalProfitPrice: "Total profit adjustment amount",
    totalSalesPrice: "Suggested total sales price",
    recordTitle: "Communication record",
    communicationExplanation: "Communication explanation",
    viewRecord: "View record",
    communicationTitle: "Communication record details",
    voucherFiles: "Voucher files",
    fileList: "File list",
    file: "File",
    viewFile: "View file",
    recordUserName: "Updater",
    recordCreateTime: "Update time",
    divider1: "Charging information",
    divider2: "Cargo information",
    divider3: "Currency information",
    divider4: "Quote summary",
    divider5: "Quote remarks",
    divider6: "Remark records",
  },
  calculator: {
    input: "Please input",
    select: "Please select",
    length: "Long(cm)",
    width: "Width(cm)",
    height: "Height(cm)",
    weight: "Weight(kg)",
    search: "Search",
    col1: "Transport service",
    col2: "Base weight unit",
    col3: "Base weight unit price",
    col4: "Additional weight",
    col5: "Additional weight unit",
    col6: "Transport time",
    day: "days",
    empty: "No data",
    remark: "Remark",
    orderBy1: "Price ascending",
    orderBy2: "Price descending"
  },
  businessEntity: {
    companyName: "Company name",
    companyLogo: "Company Logo",
    officialSeal: "Official seal",
    englishName: "English name",
    foreignLanguageName: "Foreign language name",
    establishmentDate: "Date of establishment",
    legalPerson: "Company legal person",
    region: "Registered region",
    address: "Registered address",
    registeredCapital: "Registered capital",
    remark: "Remark",
    shareHolder: "List of Shareholders",
    fullname: "Name",
    equityStake: "Percentage of shares",
    status: "Status",
    option1: "Normal",
    option2: "Disable",
    noImage: "No pictures",
    addButton: "Create business entity",
    bankAccountList: "Bank account list",
    bankAccount: "Bank account",
    accountNickName: "Account nick name",
    accountName: "Account name",
  },
  goodsInventory: {
    productName: "Product name",
    productNameEn: "Product english name",
    domesticPlaceOrigin: "Domestic place of delivered goods",
    productImages: "Product image",
    productDescription: "Product description",
    productQuotation: "Product quotation",
    customsDeclaration: "Customs declaration information",
    customsDeclarationName: "Customs declaration name",
    brand: "Brand",
    model: "Model",
    packageNumber: "Single-piece packaging quantity",
    hsCode: "HS Code",
    specification: "Specification",
    unitName: "Quotation unit",
    customerNumber: "Customer Number",
    customerName: "Company name/Supplier name",
    sixMonthAvgPrice: "Average price of buyers for 6 months (excluding tax)",
    minPrice: "Minimum price (excluding tax)",
    minPriceCustomerNumber: "Lowest price supplier number",
    minPriceCompanyName: "Company name of the lowest price supplier",
    minPriceCustomerPhone: "The supplier offering the lowest price: phone number",
    priceValidityPeriod: "Price validity period",
    priceStartEffectiveDate: "Price effective from now on",
    priceExpirationDate: "Price expiration date",
    noImage: "No pictures",
    orderBy1: "Sort information by time of entry",
    orderBy2: "Sort by date of entry",
    orderBy3: "Sort by date of departure",
    createProduct: "Create product",
    editProduct: "Edit product",
    grossWeight: "Single-piece gross weight(kg)",
    volume: "Single-piece volume(m3)",
    countryOrigin: "Place of Origin/Country",
    startDate: "Start date",
    to: "to",
    endDate: "End date",
    brandLicensing: "Brand licensing",
    brandLicensingDate: "Brand licensing period",
    sort: "Sort",
    qOrderBy1: "Descending order of quotation dates",
    qOrderBy2: "Sort by quotation date in ascending order",
    qOrderBy3: "Pre-tax purchase price in descending order",
    qOrderBy4: "Ascending order of pre-tax purchase prices",
    qOrderBy5: "Descending order of after-tax purchase prices",
    qOrderBy6: "Ascending order of after-tax purchase prices",
    qNumber: "Quotation number",
    supplier: "Supplier",
    supplierNumber: "Supplier number",
    supplierName: "Supplier name",
    preTaxPurchasePrice: "Pre-tax purchase price",
    invoicingTaxRate: "Tax rate for invoice issuance",
    invoiceType: "Invoice type",
    invoiceType1: "Value-added tax special invoice",
    invoiceType2: "General VAT Invoice",
    afterTaxPurchasePrice: "After-tax purchase price",
    invoiceIncludingTaxRate: "Invoiced with tax rate",
    productTaxAmount: "Product tax amount",
    productState: "Product state",
    normal: "Normal",
    disable: "Disable",
    quoteDate: "Quotation date",
    createQuotation: "Create quotation",
    minimumOrderQuantity: "Minimum order quantity",
    procurementConsiderations: "Procurement Considerations",
  },
  tradeOrder: {
    jobNumber: "Job number",
    orderNumber: "Order number",
    customerNumber: "Customer number",
    customerCompanyName: "Name of the client company",
    tradeTerms: "Trade terms",
    deliveryDestination: "Destination of delivery",
    totalReceive: "Total Receivables",
    receivable: "Pending collection balance",
    taxRefundTotalAmount: "Total amount eligible for tax refund",
    procurementTotalAmount: "Total amount to be paid",
    paymentBalance: "Unpayment balance",
    financialAccountNo: "Financial Ref No.",
    companyNameSn: "Customer abbreviation",
    invoiceNo: "Invoice No.",
    totalPayable: "Total payable",
    totalPayableBalance: "Payable balance",
    totalReceive: "Total receivable",
    totalReceiveBalance: "Recivable balance",
    viewCost: "View cost",
    deleteCost: "Delete cost",
    viewSell: "View sell",
    deleteSell: "Delete sell",
    subTotal: "Sub-total",
    rate: "Rate",
    totalAmount: "Total Amount",
    receTotalAmount: "Total Amount",
    profitTotalAmount: "Total Amount",
    notice: "Notice",
    deleteCheck1: "Are you sure to delete this cost?",
    deleteCheck2: "Are you sure to delete this sell?",
    nuType1: "Receivable",
    nuType2: "Payable",
    sheet1: "Debit note",
    sheet2: "Supplier costs",
    reconciliation: "Reconciliation",
    printTitle: "Trade order print",
    printOption1: "Purchase list of goods",
    printOption2: "List of sold products",
    createOrder: "Trade order generation",
    viewDraft: "View draft",
    deleteDraft: "Delete draft",
    saveDraft: "Save draft",
    draftName: "Draft name",
    productNameSn: "Product name",
    brand: "Brand",
    model: "Model",
    specifications: "Specifications",
    searchProduct: "Search product",
    noImage: "No image available",
    productName: "Product name",
    productNameEn: "Product name in english",
    customsDeclarationName: "Customs declaration name",
    customsDeclarationInfo: "Customs declaration information",
    domesticPlaceOrigin: "Domestic place of origin",
    unitName: "Quotation unit",
    hsCode: "Hs code",
    supplier: "Supplier",
    quotation: "Purchase quotation",
    entity: "Business entity",
    quantity: "Purchase quantity",
    preTaxPurchasePrice: "Pre-tax purchase price",
    invoicingTaxRate: "Invoicing tax rate",
    afterTaxPurchasePrice: "After-tax purchase price",
    minimumOrderQuantity: "Minimum order quantity",
    procurementConsiderations: "Procurement considerations",
    collapse1: "Purchase order",
    collapse2: "Sales order",
    subTitle1: "Purchase product list",
    subTitle2: "Sales product list",
    button1: "Add purchase catalog",
    button2: "Sync product",
    button3: "Include in receivables",
    total1: "Total purchase quantity",
    total2: "Total purchase amount (cny)",
    total3: "Total order sales price",
    total4: "Total order sales price (cny)",
    total5: "Total fee amount",
    total6: "Total fee amount (cny)",
    total7: "Total expected receivables for order (cny)",
    total8: "Total expected order profit (cny)",
    total9: "Profit margin",
    total10: "Total expected tax refund",
    subtotal: "Subtotal",
    refundSubtotal: "Tax refund subtotal",
    customerName: "Customer name",
    accountNo: "Bank account",
    bankAccount: "Receiving account",
    contact: "Contact person",
    phoneNumber: "Contact number",
    deliveryCountry: "Delivery country",
    deliveryDestination: "Delivery destination",
    address: "Address",
    tradeTerms: "Trade terms",
    procurementFeeRate: "Procurement fee rate",
    tradeCurrency: "Transaction currency",
    exchangeRate: "Transaction exchange rate",
    fobCurrency: "Fob local cost currency",
    fobCost: "Fob local cost",
    jobNumber: "Job number",
    orderNumber: "Order number",
    checkbox1: "Apply for export tax refund",
    salesUnitPrice: "Sales price",
    deleteSuccess: "Deletion successful",
    synError: "Please add purchase catalog first",
    quantityError: "Purchase quantity cannot be less than minimum order quantity",
    updateSuccess: "Purchase product updated",
    addSuccess: "Addition successful",
    pickerError1: "This customer does not have a bank account for receiving payments",
    pickerError2: "This business entity does not have a bank account for receiving payments",
    pickerError3: "There is no supplier for this product",
    pickerError4: "There is no quotation for this product"
  },
  procurementQuotationSettings: {
    createUnit: "Create quotation unit",
    editUnit: "Edit quotation unit",
    unitNameCN: "Unit name in chinese",
    unitNameEN: "Unit name in english",
    unitNameAR: "Unit name in arabic",
  },
  freightInquiry: {
    tableTitle: "Service quote",
    placeHolder: "Please select a country",
    divider: "Additional weight",
    col1: "Transport service",
    col2: "Base weight unit",
    col3: "Base weight unit price",
    col4: "Additional weight",
    col5: "Additional weight unit",
    col6: "Transport time",
    day: "days",
    warehouseContact: "Contact person",
    warehousePhone: "Contact number",
    warehouseAddress: "Warehouse address",
    copy: "Click to copy",
    empty: "No data",
    none: "None",
    remark: "Remark",
    supplier: "Supplier",
    area: "Area",
    bcName: "Business category",
    updateTime: "Update date",
    companyNameKeyword: "Supplier Name Keyword",
    countryName: "Country name",
    cargoCategory: "Transport service",
    freightPriceCalculator: "Freight price calculator",
    tab1: "Express check",
    tab2: "Other services",
    quotationDetail: "Quotation details",
    customerNumber: "Customer number",
    customerCompanyName: "Customer company name",
    awWay: "Access way",
    dCurrnecy: "Display currency",
    dCurrnecySymbol: "Display currency symbol",
    weight: "Weight",
    volume: "Volume",
    shipmentCount: "Number of master bills of lading",
    billCount: "Number of house bills of lading",
    cifGoodsValue: "CIF goods value",
    piecesNumber: "Number of pieces",
    storageOverdueDays: "Storage overdue days",
    conatiner20: "20 container type",
    conatiner40: "40 container type",
    conatiner40HQ: "40HQ container type",
    isCustomsInspection: "Is there any customs inspection",
    isMandatoryItem: "Is this an essential item",
    mandatory1: "Mandatory collection",
    mandatory2: "Collection upon dispatch",
    mandatory3: "Actual reimbursement based on actual expenses per order",
    notes: "Operational notes",
    feeSchedule: "Fee schedule",
    itemName: "Bill item name",
    unitName: "Billing unit name",
    costPrice: "Cost price",
    totalCostPrice: "Total cost price"
  },
  address: {
    addAddress: "Create delivery address",
    editAddress: "Edit delivery address",
    postcode: "Postcode",
    receivingName: "Consignee",
    phoneNumber: "Contact No.",
    receivingAddress: "Delivery address details",
    isDefault: "Default delivery address",
    selectAddress: "Please select address",
    chinese1: "Your china delivery address",
    chinese2: "Warehouse",
    chinese3: "Contact",
    chinese4: "Phone",
    chinese5: "Address",
    copy: "Click to copy"
  },
  myWallet: {
    accountBalance: "Account balance",
    processAccountBalance: "Amount being deducted",
    fundType1: "Recharge",
    fundType2: "Consumption",
    fundType3: "Exchange entry",
    fundType4: "Exchange expend",
    balance: "Balance",
    fundTypeStr: "Fund Type",
    tradeNumber: "Transaction number",
    rechargeAmount: "Recharge amount",
    rechargeTime: "Recharge time",
    paymentMethod: "Payment method",
    payment1: "Alipay",
    payment2: "Wechat",
    payment4: "Offline payment",
    orderState: "Order status",
    pState1: "Pending payment",
    pState2: "Paid",
    pState3: "Cancelled",
    entryState: "Entry status",
    eState1: "Pending review",
    eState2: "Posted",
    eState3: "Cancelled",
    tab1: "Recharge records",
    tab2: "Account statement",
    listButton: "Payment / View",
    rechangeButton: "Account recharge",
    payAmount: "Payment amount",
    payVoucher: "Payment voucher",
    tradeCurrency: "Transaction currency",
    accountName: "Account name",
    accountNumber: "Account number",
    tips1: "Important notes",
    tips2: "Regardless of the payment method selected, the funds will not be credited immediately after a successful recharge. They will need to be verified by an auditor, which is usually completed within 1-2 working days. Please be patient. If the funds are not credited after a long time, please contact the administrator directly for assistance.",
    cancelPayment: "Cancel payment",
    payNow: "Pay now"
  },
  paybillList: {
    totalAmount: "Total amount",
    approvedAmount: "Approved amount",
    billState1: "Unpay",
    billState2: "Paid",
    billState3: "Unreview",
    subTotalAmount: "Sub-total amount",
    subApprovedAmount: "Sub-approved amount",
    chargeMoney: "Charge items",
    payableBills: "Payable bill",
    onPay: "Pay now",
  },
  order: {
    payType: "Select payment method",
    onPay: "Pay now",
    paymentOption1: "Alipay",
    paymentOption2: "Wechat",
  },
  orderManagement: {
    search1: "Order / Express / Waybill number",
    search2: "Receiver / Shipper",
    orderNo: "Order number",
    expressNo: "Express number",
    wbNumber: "Waybill number",
    serviceProvider: "Service provider",
    none: "None",
    cargoCategory: "Transport service",
    shipper: "Shipper",
    shipperName: "Shipper name / phone",
    shipperContact: "Shipper contact",
    shipperPhoneNumber: "Shipper phone number",
    consignee: "Consignee",
    consigneeName: "Consignee name / phone",
    consigneeContact: "Consignee contact",
    declareValue: "Declared value",
    declareValueCurrency: "Declared value currency",
    itemsTitle: "Cargo details",
    weight: "Weight",
    volume: "Volume",
    boxNumber: "Number of boxes",
    orderDate: "Order date",
    addButton: "Create order",
    skuName: "Product name",
    skuQty: "Quantity",
    hsCode: "Hs code",
    companyName: "Company name",
    contactName: "Contact name",
    phoneNumber: "Phone number",
    email: "Email",
    zipCode: "Postal code",
    detailAddress: "Detailed address",
    naqel_ShippingDateTime: "Shipping time",
    naqel_DescriptionOfGoods: "Description of goods",
    naqel_NumberOfPieces: "Number of pieces",
    iMile_PackageTotalVolume: "Total package volume",
    iMile_PackageGrossWeight: "Package gross weight",
    iMile_PackageTotalCount: "Total package count",
    iMile_PackageGoodsType: "Package goods type",
    itemsTotal: "Data summary",
    totalWeight: "Total weight",
    totalValue: "Total volume",
    totalBoxNumber: "Total number of boxes",
    totalQuantity: "Total quantity of goods",
    orderDetail: "Order details",
    createOrder: "Create order",
    others: "Others",
    declareTitle: "Declaration details",
    productCategory: "Product category",
    taxFeebearingParty: "Tax payer",
  },
  exportGoodsStatistics: {
    receiveCountry: "Receive country",
    receiveCity: "Receive city",
    transportType: "Type of transportation",
    goodsName: "Goods name",
    hsCode: "Hs code",
  }
};
export default messages;
